/**
 * Standalone Isolated Typesense Storefront Engine
 * Dedicated JS for sections/gtech-typesense.liquid
 */
(function () {
  'use strict';

  var HOST = window.GTECH_TYPESENSE_HOST || 'search-shopify.gtechdigital.id';
  var PORT = Number(window.GTECH_TYPESENSE_PORT || 443);
  var PROTOCOL = window.GTECH_TYPESENSE_PROTOCOL || 'https';
  var SEARCH_KEY = window.GTECH_TYPESENSE_SEARCH_KEY || 'mU5JQ2n3ucUnSpZu7Tk1Z56FVuu8LA3Z';
  var COLLECTION_NAME = window.GTECH_TYPESENSE_COLLECTION || 'hollister_id_product_colors';

  var FALLBACK_HOST = window.GTECH_TYPESENSE_FALLBACK_HOST || 'prevention-factors-oxford-drum.trycloudflare.com';
  var FALLBACK_PORT = Number(window.GTECH_TYPESENSE_FALLBACK_PORT || 443);
  var FALLBACK_PROTOCOL = window.GTECH_TYPESENSE_FALLBACK_PROTOCOL || 'https';
  var FALLBACK_SEARCH_KEY = window.GTECH_TYPESENSE_FALLBACK_SEARCH_KEY || 'xYqa7TH6E09nK8NE9kwtLuWzGTAnBH50';
  var FALLBACK_COLLECTION = window.GTECH_TYPESENSE_FALLBACK_COLLECTION || 'hollister_product_colors';

  var root = null;
  var searchInstance = null;
  var quickViewModalId = "QuickAdd-gtech-typesense";
  var quickViewInfoId = "QuickAddInfo-gtech-typesense";

  function context() {
    return window.GTECH_TYPESENSE_CONTEXT || {};
  }

  function decodeHtmlEntities(str) {
    if (!str || typeof str !== 'string') return str;
    return str
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }

  function t(key, fallback) {
    var dict = window.GTECH_TYPESENSE_I18N || {};
    var val = (dict && dict[key] != null && dict[key] !== '') ? dict[key] : fallback;
    return decodeHtmlEntities(val);
  }

  function isSearchPage() {
    return context().pageType === 'search' || /\/search/.test(window.location.pathname);
  }

  function isCollectionPage() {
    return context().pageType === 'collection' || /\/collections\//.test(window.location.pathname);
  }

  function money(value) {
    var amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    try {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return 'Rp' + Math.round(amount).toLocaleString('id-ID');
    }
  }

  function cleanColorName(value) {
    return String(value || '')
      .replace(/_/g, ' ')
      .replace(/-/g, ' ')
      .replace(/pattern.*$/i, '')
      .replace(/[0-9]/g, '')
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function escapeAttr(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  // Size Sorting Rules
  var sizeFacetOrder = [
    "000", "00", "0", "2", "4", "6", "8", "10", "12", "14", "16", "18",
    "XXS", "XXS/XS", "XS", "XS/S", "S", "S/M", "M", "M/L", "L", "L/XL", "XL", "XXL", "XXXL", "ONE SIZE"
  ];

  function sizeFacetRank(value) {
    var label = String(value || "").trim().toUpperCase();
    var exact = sizeFacetOrder.indexOf(label);
    if (exact > -1) return exact;
    var numeric = Number(label);
    if (Number.isFinite(numeric)) return 100 + numeric;
    return 1000 + label.charCodeAt(0);
  }

  function transformSizeFacetItems(items) {
    return (items || []).slice().sort(function (a, b) {
      var rankA = sizeFacetRank(a && (a.value || a.label));
      var rankB = sizeFacetRank(b && (b.value || b.label));
      if (rankA !== rankB) return rankA - rankB;
      return String((a && (a.label || a.value)) || "").localeCompare(String((b && (b.label || b.value)) || ""));
    });
  }

  function formatSizeFacetDOM(currentRoot) {
    if (!currentRoot) return;
    var sizeLabels = currentRoot.querySelectorAll('.gtech-instant__facet[data-gtech-instant-panel="available_sizes"] .ais-RefinementList-label');
    sizeLabels.forEach(function (labelEl) {
      var textSpan = labelEl.querySelector('.ais-RefinementList-labelText') || labelEl;
      var text = (textSpan.textContent || '').trim();
      if (/one\s*size/i.test(text) || text.length >= 6) {
        labelEl.classList.add('is-long-size');
      } else {
        labelEl.classList.remove('is-long-size');
      }
    });
  }

  function transformCategoryFacetItems(items) {
    return (items || []).slice().map(function (item) {
      var raw = String(item.label || item.value || '');
      var clean = raw;
      if (clean.indexOf(' > ') !== -1) {
        clean = clean.split(' > ').pop().trim();
      }
      return Object.assign({}, item, { label: clean });
    });
  }

  function keywordMatchesCategory(text, keyword) {
    var t = String(text || '').trim().toLowerCase();
    var k = String(keyword || '').trim().toLowerCase();
    if (!t || !k) return false;
    if (t === k) return true;
    var tNorm = t.replace(/\band\b/g, '&').replace(/[^a-z0-9&]/g, ' ').replace(/\s+/g, ' ').trim();
    var kNorm = k.replace(/\band\b/g, '&').replace(/[^a-z0-9&]/g, ' ').replace(/\s+/g, ' ').trim();
    if (tNorm === kNorm) return true;
    if (tNorm.indexOf(kNorm) !== -1 || kNorm.indexOf(tNorm) !== -1) return true;
    return false;
  }

  function groupCategoryFacetInDOM(currentRoot) {
    if (!currentRoot) return;

    var drawer = currentRoot.querySelector('[data-gtech-instant-drawer]');
    // Grouping with headers TOPS, BOTTOMS, OTHER only applies in Filter & Sort (data-active-panel="all")
    // When opening the single Category pill drawer (data-active-panel !== "all"), do not show group headers
    if (drawer && drawer.getAttribute('data-active-panel') && drawer.getAttribute('data-active-panel') !== 'all') {
      var headers = currentRoot.querySelectorAll('.gtech-instant__facet-group-header');
      headers.forEach(function (h) { h.remove(); });
      return;
    }

    var catContainers = currentRoot.querySelectorAll(
      '.gtech-instant__facet[data-gtech-instant-panel="category_group"], .gtech-instant__facet[data-gtech-instant-panel="category_facet"], .gtech-instant__facet[data-gtech-instant-panel="category_name"]'
    );
    if (catContainers.length === 0) return;

    var contextCfg = (window.GTECH_TYPESENSE_CONTEXT && window.GTECH_TYPESENSE_CONTEXT.categoryGrouping) || {};

    function parseKeywordList(val, fallback) {
      if (typeof val === 'string') {
        return val.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      }
      return fallback;
    }

    var defaultTops = ['blouses', 'graphic tees', 'tees & tanks', 'polos', 'shirts', 'sweaters', 'hoodies & sweatshirts'];
    var defaultBottoms = ['jeans', 'pants', 'sweatpants & leggings', 'shorts', 'skirts'];
    var defaultDresses = ['dresses'];

    var topsKeywords = parseKeywordList(contextCfg.tops, defaultTops);
    var bottomsKeywords = parseKeywordList(contextCfg.bottoms, defaultBottoms);
    var dressesKeywords = parseKeywordList(contextCfg.dresses, defaultDresses);

    var groupOrder = [
      {
        key: 'TOPS',
        title: t('group_tops', 'TOPS'),
        items: topsKeywords
      },
      {
        key: 'BOTTOMS',
        title: t('group_bottoms', 'BOTTOMS'),
        items: bottomsKeywords
      },
      {
        key: 'DRESSES & ROMPERS',
        title: t('group_dresses', 'DRESSES & ROMPERS'),
        items: dressesKeywords
      },
      {
        key: 'OTHER',
        title: t('group_other', 'OTHER'),
        items: []
      }
    ];

    catContainers.forEach(function (container) {
      var list = container.querySelector('.ais-RefinementList-list');
      if (!list) return;

      var existingHeaders = list.querySelectorAll('.gtech-instant__facet-group-header');
      existingHeaders.forEach(function (h) { h.remove(); });

      var items = Array.from(list.querySelectorAll('.ais-RefinementList-item'));
      if (items.length === 0) return;

      var grouped = {
        'TOPS': [],
        'BOTTOMS': [],
        'DRESSES & ROMPERS': [],
        'OTHER': []
      };

      items.forEach(function (itemEl) {
        var labelEl = itemEl.querySelector('.ais-RefinementList-labelText') || itemEl.querySelector('label') || itemEl;
        var text = (labelEl.textContent || '').trim().toLowerCase();

        // Match strictly based on dynamic settings. Anything not in TOPS, BOTTOMS, DRESSES automatically goes to OTHER.
        var matchedGroup = 'OTHER';
        if (topsKeywords.some(function (k) { return keywordMatchesCategory(text, k); })) {
          matchedGroup = 'TOPS';
        } else if (bottomsKeywords.some(function (k) { return keywordMatchesCategory(text, k); })) {
          matchedGroup = 'BOTTOMS';
        } else if (dressesKeywords.some(function (k) { return keywordMatchesCategory(text, k); })) {
          matchedGroup = 'DRESSES & ROMPERS';
        } else {
          matchedGroup = 'OTHER';
        }

        if (!grouped[matchedGroup]) {
          grouped[matchedGroup] = [];
        }

        grouped[matchedGroup].push({
          el: itemEl,
          text: text
        });
      });

      // Clear list and re-append grouped with headers
      items.forEach(function (el) { el.remove(); });

      groupOrder.forEach(function (grp) {
        var groupItems = grouped[grp.key];
        if (groupItems && groupItems.length > 0) {
          var header = document.createElement('li');
          header.className = 'gtech-instant__facet-group-header';
          header.setAttribute('role', 'presentation');
          header.textContent = grp.title;
          list.appendChild(header);

          groupItems.sort(function (a, b) {
            var idxA = grp.items.findIndex(function (k) { return a.text.indexOf(k) !== -1; });
            var idxB = grp.items.findIndex(function (k) { return b.text.indexOf(k) !== -1; });
            if (idxA === -1) idxA = 999;
            if (idxB === -1) idxB = 999;
            if (idxA !== idxB) return idxA - idxB;
            return a.text.localeCompare(b.text);
          });

          groupItems.forEach(function (gi) {
            list.appendChild(gi.el);
          });
        }
      });
    });
  }

  var lengthFacetOrder = ["Short", "Regular", "Long", "Petite", "Tall", "28", "30", "32", "34", "36"];
  function transformLengthFacetItems(items) {
    return (items || []).slice().sort(function (a, b) {
      var labelA = String((a && (a.label || a.value)) || "").trim();
      var labelB = String((b && (b.label || b.value)) || "").trim();
      var idxA = lengthFacetOrder.indexOf(labelA);
      var idxB = lengthFacetOrder.indexOf(labelB);
      if (idxA > -1 && idxB > -1) return idxA - idxB;
      if (idxA > -1) return -1;
      if (idxB > -1) return 1;
      return labelA.localeCompare(labelB);
    });
  }

  var riseFacetOrder = ["High Rise", "Mid Rise", "Low Rise", "Ultra Low Rise", "Adjustable Rise", "Ultra High Rise"];
  function transformRiseFacetItems(items) {
    return (items || []).slice().sort(function (a, b) {
      var labelA = String((a && (a.label || a.value)) || "").trim();
      var labelB = String((b && (b.label || b.value)) || "").trim();
      var idxA = riseFacetOrder.indexOf(labelA);
      var idxB = riseFacetOrder.indexOf(labelB);
      if (idxA > -1 && idxB > -1) return idxA - idxB;
      if (idxA > -1) return -1;
      if (idxB > -1) return 1;
      return labelA.localeCompare(labelB);
    });
  }

  function transformAlphabeticalFacetItems(items) {
    return (items || []).slice().sort(function (a, b) {
      var labelA = String((a && (a.label || a.value)) || "").trim();
      var labelB = String((b && (b.label || b.value)) || "").trim();
      return labelA.localeCompare(labelB);
    });
  }

  // High-performance Shopify CDN Image URL Transformer & Optimizer
  function shopifyImageUrl(url, width, crop) {
    if (!url || typeof url !== 'string') return '';
    if (!/cdn\.shopify\.com/i.test(url)) return url;
    try {
      var parts = url.split('?');
      var baseUrl = parts[0];
      var searchParams = new URLSearchParams(parts[1] || '');
      if (width) searchParams.set('width', String(width));
      if (crop) searchParams.set('crop', crop);
      return baseUrl + '?' + searchParams.toString();
    } catch (e) {
      var clean = url.replace(/([?&])(width|crop)=[^&]*/g, '$1').replace(/[?&]+$/, '');
      var sep = clean.indexOf('?') === -1 ? '?' : '&';
      var params = [];
      if (width) params.push('width=' + width);
      if (crop) params.push('crop=' + (crop || 'center'));
      return clean + sep + params.join('&');
    }
  }

  function generateSrcSet(url) {
    if (!url || typeof url !== 'string' || !/cdn\.shopify\.com/i.test(url)) return '';
    return [
      shopifyImageUrl(url, 240) + ' 240w',
      shopifyImageUrl(url, 360) + ' 360w',
      shopifyImageUrl(url, 533) + ' 533w',
      shopifyImageUrl(url, 720) + ' 720w'
    ].join(', ');
  }

  function isItemInWishlist(productId, variantId, variantColor) {
    try {
      var list = JSON.parse(localStorage.getItem('myWishlist') || '[]');
      if (!Array.isArray(list)) return false;
      return list.some(function (item) {
        if (!item) return false;
        if (variantId && item.variantId && String(item.variantId) === String(variantId)) return true;
        if (productId && item.id && String(item.id) === String(productId)) {
          if (variantColor && item.variantColor) {
            return String(item.variantColor).toLowerCase() === String(variantColor).toLowerCase();
          }
          return true;
        }
        return false;
      });
    } catch (e) {
      return false;
    }
  }

  function showWishlistFlyout() {
    var existingFlyout = document.querySelector('[data-testid="my-list-flyout"]');
    if (existingFlyout) existingFlyout.remove();

    var labels = window.wishlistLabel || {
      customerLoggedIn: false,
      addToWishlist: 'Item added to your List',
      signIn: 'Sign In',
      listSubtext: ' to save across all devices or ',
      createAcc: 'Create an Account',
      itemSaveLogin: 'Item added to your List',
      viewList: 'View List'
    };

    var flyoutClasses = '';
    var smallMessageHTML = '';

    if (!labels.customerLoggedIn) {
      smallMessageHTML =
        '<div>' +
          '<p class="catalog-MyListNotifications-module__bigMessage" data-property="GLB_GUEST_ITEM_SAVED">' +
            '<span class="catalog-MyListNotifications-module__heart">' +
              '<span aria-hidden="true" class="icon" data-icon="heart-filled-hco"></span>' +
            '</span>' +
            '<span class="adding_text">' + (labels.addToWishlist || 'Item added to your List') + '</span>' +
          '</p>' +
          '<div class="catalog-MyListNotifications-module__smallMessage">' +
            '<p>' +
              '<span data-property="GLB_SIGNIN_HEARTS">' +
                '<modal-opener data-modal="#LoginModal">' +
                  '<button class="login-trigger signIn" data-variant="tertiary-light" data-redirect="/account">' +
                    '<span class="underline">' + (labels.signIn || 'Sign In') + '</span>' +
                  '</button>' +
                '</modal-opener>' +
                (labels.listSubtext || ' to save across all devices or ') +
              '</span>' +
            '</p>' +
            '<p>' +
              '<span data-property="GLB_CREATEACCOUNTLINK">' +
                '<button class="login-trigger signIn" id="createAccountModal" data-variant="tertiary-light" data-redirect="/account">' +
                  '<span class="underline">' + (labels.createAcc || 'Create an Account') + '</span>' +
                '</button>' +
              '</span>' +
            '</p>' +
          '</div>' +
        '</div>';
      flyoutClasses = 'catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime catalog-MyListNotifications-module__loggedOut';
    } else {
      smallMessageHTML =
        '<div class="catalog-MyListNotifications-module__smallMessage">' +
          '<p>' +
            '<span class="catalog-MyListNotifications-module__heart">' +
              '<span aria-hidden="true" class="icon" data-icon="heart-filled-hco"></span>' +
            '</span>' +
            (labels.itemSaveLogin || 'Item added to your List') +
          '</p>' +
        '</div>';
      flyoutClasses = 'catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime';
    }

    var flyoutHTML =
      '<div data-testid="my-list-flyout" class="flyout-top-gap">' +
        '<div class="' + flyoutClasses + '">' +
          '<div>' +
            smallMessageHTML +
            '<p class="catalog-MyListNotifications-module__myListButton block">' +
              '<a class="button submit-btn wishlist-flybtn" data-full-width="true" data-theme="inverse" href="/pages/my-list">' + (labels.viewList || 'View List') + '</a>' +
            '</p>' +
          '</div>' +
        '</div>' +
      '</div>';

    var isAppView = window.location.search.includes('app-view=true');
    if (isAppView) {
      var appViewFlyout =
        '<div class="app-view-wishlist-flyout">' +
          '<p class="flyout-text">The item has been saved</p>' +
          '<a href="/pages/my-list" class="flyout-btn">My List</a>' +
        '</div>';
      document.body.insertAdjacentHTML('beforeend', appViewFlyout);
      setTimeout(function () {
        var flyout = document.querySelector('.app-view-wishlist-flyout');
        if (flyout) flyout.remove();
      }, 3000);
    } else {
      var header = document.querySelector('.header-wrapper') || document.querySelector('header');
      if (header) {
        header.insertAdjacentHTML('beforeend', flyoutHTML);
        if (typeof toggleFlyoutGap === 'function') toggleFlyoutGap();
      }
      setTimeout(function () {
        var flyout = document.querySelector('[data-testid="my-list-flyout"]');
        if (flyout) flyout.remove();
      }, 3000);
    }
  }

  function handleWishlistToggle(btn, card) {
    var productId = btn.getAttribute('data-product-id') || '';
    var variantId = btn.getAttribute('data-variant-id') || '';
    var title = btn.getAttribute('data-product-title') || '';
    var handle = btn.getAttribute('data-product-handle') || '';
    var variantColor = btn.getAttribute('data-variant-color') || '';

    var wishlist = [];
    try {
      wishlist = JSON.parse(localStorage.getItem('myWishlist') || '[]');
      if (!Array.isArray(wishlist)) wishlist = [];
    } catch (e) {
      wishlist = [];
    }

    var existingIndex = wishlist.findIndex(function (item) {
      if (!item) return false;
      if (variantId && item.variantId && String(item.variantId) === String(variantId)) return true;
      if (productId && item.id && String(item.id) === String(productId)) {
        if (variantColor && item.variantColor) {
          return String(item.variantColor).toLowerCase() === String(variantColor).toLowerCase();
        }
        return true;
      }
      return false;
    });

    var iconSpan = btn.querySelector('.icon');

    if (existingIndex > -1) {
      // Remove from wishlist
      wishlist.splice(existingIndex, 1);
      localStorage.setItem('myWishlist', JSON.stringify(wishlist));
      btn.classList.remove('is-in-wishlist');
      btn.setAttribute('aria-label', 'Add to Wishlist');
      if (iconSpan) {
        iconSpan.setAttribute('data-icon', 'heart');
      }
    } else {
      // Add to wishlist
      var newItem = {
        id: productId,
        variantId: variantId,
        title: title,
        handle: handle,
        variantColor: variantColor,
        addedAt: Date.now()
      };
      wishlist.push(newItem);
      localStorage.setItem('myWishlist', JSON.stringify(wishlist));
      btn.classList.add('is-in-wishlist');
      btn.setAttribute('aria-label', 'Remove from Wishlist');
      if (iconSpan) {
        iconSpan.setAttribute('data-icon', 'heart-filled-hco');
      }

      // Trigger flyout notification popup
      showWishlistFlyout();
    }

    // Sync with global Mapclub / Shopify customer wishlist
    if (typeof syncWishlist === 'function') {
      try { syncWishlist(); } catch (err) {}
    }
  }

  function hitTemplate(hit, hitIndex) {
    var shouldHideNoImage = context().hideNoImageProducts !== false && (root ? root.getAttribute('data-hide-no-image') !== 'false' : true);
    var handle = hit.handle || '';
    var url = '/products/' + handle;
    if (hit.primary_variant_id) url += '?variant=' + hit.primary_variant_id;

    var title = hit.title || 'Product';
    var color = cleanColorName(hit.color_label || hit.base_color);
    var variantId = hit.primary_variant_id || hit.id || '';
    var productId = hit.product_id || '';
    var mainImg = hit.main_image || hit.image || '';
    var hoverImg = hit.hover_image || '';
    var price = money(hit.price);
    var compare = hit.compare_at_price && Number(hit.compare_at_price) > Number(hit.price) ? money(hit.compare_at_price) : '';

    if (shouldHideNoImage && (!mainImg || String(mainImg).trim() === '' || String(mainImg).includes('no-image'))) {
      return '';
    }

    var indexOnPage = typeof hitIndex === 'number' ? hitIndex : (typeof hit.__hitIndex === 'number' ? hit.__hitIndex : 99);
    var isLcpCandidate = indexOnPage < 4;
    var isTopPriority = indexOnPage < 2;

    // Swatches Markup
    var swatchesHtml = '';
    if (hit.swatches_json) {
      try {
        var swatches = JSON.parse(hit.swatches_json);
        if (Array.isArray(swatches) && swatches.length > 0) {
          // Filter out swatches without main image if hideNoImage is active
          if (shouldHideNoImage) {
            swatches = swatches.filter(function (s) {
              var sImg = s.main_image || s.image_src || s.image || '';
              return sImg && String(sImg).trim() !== '' && !String(sImg).includes('no-image');
            });
          }

          // Resolve mainImg and hoverImg for the specific color family
          var activeSwIndex = -1;
          for (var i = 0; i < swatches.length; i++) {
            var s = swatches[i];
            var sKey = s.color_key || s.key || '';
            if (sKey && (sKey === hit.color_key || sKey.toLowerCase() === String(hit.color_key || '').toLowerCase())) {
              activeSwIndex = i;
              break;
            }
          }

          if (activeSwIndex > -1) {
            var activeSw = swatches[activeSwIndex];
            var activeMain = activeSw.main_image || activeSw.image_src || '';
            if (activeMain) {
              mainImg = activeMain;
              var activeHover = activeSw.hover_image || activeSw.hover_src || '';
              if (!activeHover && /-1\.jpg/i.test(activeMain)) {
                activeHover = activeMain.replace(/-1\.jpg/i, '-2.jpg');
              }
              hoverImg = (activeHover && activeHover !== activeMain) ? activeHover : '';
            }

            // Always bring the selected/active swatch to position 0 so it is never hidden behind overflow
            if (activeSwIndex > 0) {
              var activeItem = swatches.splice(activeSwIndex, 1)[0];
              swatches.unshift(activeItem);
            }
          }

          swatchesHtml = swatches.map(function (sw, index) {
            var swImg = sw.swatch_image || sw.swatchImage || '';
            if (swImg && (/0100-HLI/i.test(swImg) || swImg === sw.main_image)) {
              var swKeyClean = (sw.color_key || sw.key || '').toLowerCase().replace(/\s+/g, '_').trim();
              if (swKeyClean) {
                swImg = 'https://cdn.shopify.com/s/files/1/0673/8362/3766/files/' + swKeyClean + '.jpg';
              }
            }

            // Ultra-optimized 44x44px swatch micro-thumbnail
            var optSwImg = swImg ? shopifyImageUrl(swImg, 44, 'center') : '';

            var swMain = sw.main_image || sw.image_src || sw.image || mainImg;
            var swHover = sw.hover_image || sw.hover_src || '';
            if (!swHover && swMain && /-1\.jpg/i.test(swMain)) {
              swHover = swMain.replace(/-1\.jpg/i, '-2.jpg');
            }
            if (swHover === swMain) swHover = '';

            var swLabel = sw.color_label || sw.color_raw_label || sw.base_color || '';
            var swKey = sw.color_key || sw.key || '';
            var swVarId = sw.primary_variant_id || sw.variant_id || '';
            var isActive = (swKey === hit.color_key) || (swKey && swKey.toLowerCase() === String(hit.color_key || '').toLowerCase()) || (index === 0 && activeSwIndex > -1);
            var isHidden = index >= 6;
            var isSoldOut = sw.inventory_available === false;

            var swColor = (sw.color_hex && sw.color_hex !== '#FFFFFF') ? sw.color_hex : '#d8d4ce';
            var styleParts = ['--swatch-color: ' + swColor];
            if (optSwImg) styleParts.push("--swatch-image: url('" + optSwImg + "')");
            var styleAttr = styleParts.join(';');

            return (
              '<a class="gtech-instant-card__swatch' + (isActive ? ' is-active is-default-active' : '') + (isHidden ? ' is-hidden' : '') + (isSoldOut ? ' is-soldout' : '') + '" ' +
              'href="/products/' + (sw.handle || handle) + '?variant=' + (swVarId || '') + '" ' +
              'title="' + escapeAttr(swLabel) + (isSoldOut ? ' (' + t('sold_out', 'Sold Out') + ')' : '') + '" ' +
              'data-variant-id="' + escapeAttr(swVarId) + '" ' +
              'data-media-src="' + escapeAttr(shopifyImageUrl(swMain, 533)) + '" ' +
              'data-media-srcset="' + escapeAttr(generateSrcSet(swMain)) + '" ' +
              'data-hover-src="' + escapeAttr(shopifyImageUrl(swHover, 533)) + '" ' +
              'data-color-label="' + escapeAttr(swLabel) + '" ' +
              'style="' + styleAttr + '">' +
              '<span class="gtech-instant-card__swatch-dot"></span>' +
              '</a>'
            );
          }).join('');

          if (swatches.length > 6) {
            var remaining = swatches.length - 6;
            var moreTpl = t('more_colors', '+{count} more colors').replace('{count}', remaining);
            swatchesHtml += '<a class="gtech-instant-card__swatch-more" href="' + url + '" title="' + escapeAttr(moreTpl) + '" aria-label="' + escapeAttr(moreTpl) + '">+' + remaining + '</a>';
          }
        }
      } catch (e) {}
    }

    var validHover = hoverImg && hoverImg !== mainImg ? hoverImg : '';

    // Primary LCP Optimized Image Attributes
    var optMainSrc = shopifyImageUrl(mainImg, 533);
    var mainSrcSet = generateSrcSet(mainImg);
    var sizesAttr = '(min-width: 1200px) 25vw, (min-width: 768px) 33vw, 50vw';

    var loadingAttr = isLcpCandidate ? 'loading="eager"' : 'loading="lazy"';
    var priorityAttr = isTopPriority ? 'fetchpriority="high"' : (isLcpCandidate ? 'fetchpriority="auto"' : 'fetchpriority="low"');

    // Hover image markup (deferred loading - populated on-demand on mouseenter)
    var hoverImageHtml = '';
    if (validHover) {
      var optHoverSrc = shopifyImageUrl(validHover, 533);
      hoverImageHtml = '<img class="gtech-instant-card__hover-image" ' +
        'data-hover-src="' + escapeAttr(optHoverSrc) + '" ' +
        'alt="" loading="lazy" decoding="async" fetchpriority="low" width="533" height="666" ' +
        'onerror="this.style.opacity=\'0\';this.style.display=\'none\';this.setAttribute(\'hidden\',\'\');">';
    }

    var inWishlist = isItemInWishlist(productId, variantId, color);
    var heartIcon = inWishlist ? 'heart-filled-hco' : 'heart';
    var wishlistClass = 'gtech-instant-card__wishlist wishlist-collection-icon mbl-wishlist-collection-icon' + (inWishlist ? ' is-in-wishlist' : '');

    // Product Grouping / Matching Set Badge from Typesense (Plain text label, non-clickable, no underline)
    var groupBadgeHtml = '';
    if (hit.group_label && String(hit.group_label).trim() !== '') {
      groupBadgeHtml =
        '<div class="gtech-instant-card__group-badge matching-set-badge">' +
          '<span class="gtech-instant-card__group-label">' +
            escapeAttr(hit.group_label) +
          '</span>' +
        '</div>';
    }

    // BOGO Promo Price Note
    var bogoBadgeHtml = '';
    var bogoCfg = window.BOGO_CONFIG || (window.GTECH_TYPESENSE_CONTEXT && window.GTECH_TYPESENSE_CONTEXT.bogo);
    if (bogoCfg && bogoCfg.enabled && bogoCfg.tag) {
      var docTags = [];
      if (Array.isArray(hit.tags)) {
        docTags = hit.tags;
      } else if (typeof hit.tags === 'string') {
        try {
          var parsedTags = JSON.parse(hit.tags);
          if (Array.isArray(parsedTags)) docTags = parsedTags;
          else docTags = [hit.tags];
        } catch (e) {
          docTags = hit.tags.split(',');
        }
      }

      var targetTag = String(bogoCfg.tag).trim().toLowerCase();
      var isBogo = docTags.some(function (t) {
        return String(t || '').trim().toLowerCase() === targetTag;
      });

      if (isBogo) {
        var basePrice = Number(hit.price);
        if (Number.isFinite(basePrice) && basePrice > 0) {
          var multiplier = Number(bogoCfg.multiplier) || (100 - (Number(bogoCfg.percent) || 25));
          var effectivePrice = Math.floor((basePrice * multiplier) / 100);
          var bogoFormatted = money(effectivePrice);
          var bogoLabel = bogoCfg.label || 'Price After BOGO 50% Off';
          bogoBadgeHtml =
            '<div class="bogo-price-note mt-[3px]">' +
              '<span class="bogo-price">' + escapeAttr(bogoFormatted) + '</span>' +
              '<span class="bogo-text ml-1">' + escapeAttr(bogoLabel) + '</span>' +
            '</div>';
        }
      }
    }

    return (
      '<article class="gtech-instant-card" ' +
        'data-handle="' + escapeAttr(handle) + '" ' +
        'data-product-id="' + escapeAttr(productId) + '" ' +
        'data-variant-id="' + escapeAttr(variantId) + '" ' +
        'data-default-media-src="' + escapeAttr(optMainSrc) + '" ' +
        'data-default-media-srcset="' + escapeAttr(mainSrcSet) + '" ' +
        'data-default-hover-src="' + escapeAttr(validHover ? shopifyImageUrl(validHover, 533) : '') + '" ' +
        'data-default-color-label="' + escapeAttr(color) + '" ' +
        'data-default-url="' + escapeAttr(url) + '">' +
        '<button type="button" class="' + wishlistClass + '" ' +
          'data-product-id="' + escapeAttr(productId) + '" ' +
          'data-product-title="' + escapeAttr(title) + '" ' +
          'data-product-handle="' + escapeAttr(handle) + '" ' +
          'data-variant-id="' + escapeAttr(variantId) + '" ' +
          'data-variant-color="' + escapeAttr(color) + '" ' +
          'aria-label="' + (inWishlist ? escapeAttr(t('remove_from_wishlist', 'Remove from Wishlist')) : escapeAttr(t('add_to_wishlist', 'Add to Wishlist'))) + '">' +
          '<span aria-hidden="true" class="icon" data-icon="' + heartIcon + '" data-icon-size="m"></span>' +
        '</button>' +
        '<div class="gtech-instant-card__media-wrap">' +
          '<a class="gtech-instant-card__media" href="' + url + '" title="' + escapeAttr(title) + '">' +
            '<img class="gtech-instant-card__image" ' +
              'src="' + escapeAttr(optMainSrc) + '" ' +
              (mainSrcSet ? 'srcset="' + escapeAttr(mainSrcSet) + '" sizes="' + escapeAttr(sizesAttr) + '" ' : '') +
              'alt="' + escapeAttr(title) + '" ' +
              loadingAttr + ' ' +
              priorityAttr + ' ' +
              'decoding="async" width="533" height="666">' +
            hoverImageHtml +
          '</a>' +
          '<div class="gtech-instant-card__quickview">' +
            '<modal-opener data-modal="#' + escapeAttr(quickViewModalId) + '">' +
              '<button type="button" class="gtech-instant-card__quickview-button" data-product-url="' + url + '" data-product-handle="' + escapeAttr(handle) + '" data-variant-id="' + escapeAttr(variantId) + '" aria-label="' + escapeAttr(t('quick_view', 'Quick View')) + ' ' + escapeAttr(title) + '">' +
                '<span aria-hidden="true" class="icon" data-icon="zoom-plus"></span>' +
                '<span>' + escapeAttr(t('quick_view', 'Quick View')) + '</span>' +
              '</button>' +
            '</modal-opener>' +
          '</div>' +
        '</div>' +
        '<div class="gtech-instant-card__content">' +
          '<div class="gtech-instant-card__swatches">' + swatchesHtml + '</div>' +
          '<a class="gtech-instant-card__title" href="' + url + '">' + escapeAttr(title) + '</a>' +
          '<div class="gtech-instant-card__price' + (compare ? ' gtech-instant-card__price--sale' : '') + '">' +
            (compare ? (
              '<span class="gtech-instant-card__compare">' + compare + '</span>' +
              '<span class="gtech-instant-card__price-sale">' + price + '</span>' +
              '<span class="gtech-instant-card__clearance">' + escapeAttr(t('clearance', 'Clearance')) + '</span>'
            ) : (
              '<span class="gtech-instant-card__price-regular">' + price + '</span>'
            )) +
          '</div>' +
          bogoBadgeHtml +
          groupBadgeHtml +
        '</div>' +
      '</article>'
    );
  }

  function bindCardEvents(scope) {
    var cards = scope.querySelectorAll('.gtech-instant-card');
    cards.forEach(function (card) {
      // 1. Card-level hover/touch listener to hydrate hover image on demand
      function prepareHoverImage() {
        var hoverImg = card.querySelector('.gtech-instant-card__hover-image');
        if (hoverImg && !hoverImg.src) {
          var hSrc = hoverImg.getAttribute('data-hover-src');
          if (hSrc) hoverImg.src = hSrc;
        }
      }
      card.addEventListener('mouseenter', prepareHoverImage, { passive: true });
      card.addEventListener('touchstart', prepareHoverImage, { passive: true, once: true });

      // 2. Swatch hover preview & restore functionality
      var swatchesContainer = card.querySelector('.gtech-instant-card__swatches');
      var swatches = card.querySelectorAll('.gtech-instant-card__swatch');
      var mainImg = card.querySelector('.gtech-instant-card__image');
      var hoverImg = card.querySelector('.gtech-instant-card__hover-image');
      var labelEl = card.querySelector('.gtech-instant-card__variant');
      var mediaLink = card.querySelector('.gtech-instant-card__media');
      var titleLink = card.querySelector('.gtech-instant-card__title');
      var quickBtn = card.querySelector('.gtech-instant-card__quickview-button');
      var wishlistBtn = card.querySelector('.gtech-instant-card__wishlist');

      // Helper function to restore the card back to its default state
      function restoreDefaultState() {
        var defMedia = card.getAttribute('data-default-media-src');
        var defSrcSet = card.getAttribute('data-default-media-srcset');
        var defHover = card.getAttribute('data-default-hover-src');
        var defLabel = card.getAttribute('data-default-color-label');
        var defUrl = card.getAttribute('data-default-url');
        var productId = card.getAttribute('data-product-id');
        var defVarId = card.getAttribute('data-variant-id');

        if (mainImg && defMedia) {
          mainImg.src = defMedia;
          if (defSrcSet) {
            mainImg.srcset = defSrcSet;
          } else {
            mainImg.removeAttribute('srcset');
          }
        }

        if (hoverImg) {
          if (defHover) {
            hoverImg.style.display = '';
            hoverImg.style.opacity = '';
            hoverImg.src = defHover;
            hoverImg.removeAttribute('hidden');
          } else {
            hoverImg.setAttribute('hidden', '');
            hoverImg.style.display = 'none';
          }
        }

        if (labelEl && defLabel) {
          labelEl.textContent = cleanColorName(defLabel);
        }

        if (defUrl) {
          if (mediaLink) mediaLink.setAttribute('href', defUrl);
          if (titleLink) titleLink.setAttribute('href', defUrl);
          if (quickBtn) quickBtn.setAttribute('data-product-url', defUrl);
        }

        if (wishlistBtn) {
          if (defVarId) wishlistBtn.setAttribute('data-variant-id', defVarId);
          if (defLabel) wishlistBtn.setAttribute('data-variant-color', defLabel);
          var isDefInWishlist = isItemInWishlist(productId, defVarId, defLabel);
          var iconSpan = wishlistBtn.querySelector('.icon');
          if (isDefInWishlist) {
            wishlistBtn.classList.add('is-in-wishlist');
            wishlistBtn.setAttribute('aria-label', 'Remove from Wishlist');
            if (iconSpan) iconSpan.setAttribute('data-icon', 'heart-filled-hco');
          } else {
            wishlistBtn.classList.remove('is-in-wishlist');
            wishlistBtn.setAttribute('aria-label', 'Add to Wishlist');
            if (iconSpan) iconSpan.setAttribute('data-icon', 'heart');
          }
        }

        // Reset active swatch ring back to default active swatch
        swatches.forEach(function (s) {
          if (s.classList.contains('is-default-active')) {
            s.classList.add('is-active');
          } else {
            s.classList.remove('is-active');
          }
        });
      }

      // Handle hover on individual swatches
      if (swatches.length > 0) {
        swatches.forEach(function (swatch) {
          swatch.addEventListener('mouseenter', function () {
            var newMedia = swatch.getAttribute('data-media-src');
            var newMediaSrcSet = swatch.getAttribute('data-media-srcset');
            var newHover = swatch.getAttribute('data-hover-src');
            var newLabel = swatch.getAttribute('data-color-label');
            var newUrl = swatch.getAttribute('href');
            var swVarId = swatch.getAttribute('data-variant-id');
            var productId = card.getAttribute('data-product-id');

            if (mainImg && newMedia) {
              mainImg.src = newMedia;
              if (newMediaSrcSet) {
                mainImg.srcset = newMediaSrcSet;
              } else {
                mainImg.removeAttribute('srcset');
              }
            }

            if (hoverImg) {
              if (!hoverImg.dataset.errorBound) {
                hoverImg.dataset.errorBound = 'true';
                hoverImg.addEventListener('error', function () {
                  this.style.opacity = '0';
                  this.style.display = 'none';
                  this.setAttribute('hidden', '');
                });
              }
              if (newHover && newHover !== newMedia) {
                hoverImg.style.display = '';
                hoverImg.style.opacity = '';
                hoverImg.src = newHover;
                hoverImg.removeAttribute('hidden');
              } else {
                hoverImg.setAttribute('hidden', '');
                hoverImg.style.display = 'none';
              }
            }

            if (labelEl && newLabel) {
              labelEl.textContent = cleanColorName(newLabel);
            }

            if (newUrl) {
              if (mediaLink) mediaLink.setAttribute('href', newUrl);
              if (titleLink) titleLink.setAttribute('href', newUrl);
              if (quickBtn) quickBtn.setAttribute('data-product-url', newUrl);
            }

            if (wishlistBtn) {
              if (swVarId) wishlistBtn.setAttribute('data-variant-id', swVarId);
              if (newLabel) wishlistBtn.setAttribute('data-variant-color', newLabel);
              var isSwInWishlist = isItemInWishlist(productId, swVarId, newLabel);
              var iconSpan = wishlistBtn.querySelector('.icon');
              if (isSwInWishlist) {
                wishlistBtn.classList.add('is-in-wishlist');
                wishlistBtn.setAttribute('aria-label', 'Remove from Wishlist');
                if (iconSpan) iconSpan.setAttribute('data-icon', 'heart-filled-hco');
              } else {
                wishlistBtn.classList.remove('is-in-wishlist');
                wishlistBtn.setAttribute('aria-label', 'Add to Wishlist');
                if (iconSpan) iconSpan.setAttribute('data-icon', 'heart');
              }
            }

            swatches.forEach(function (s) { s.classList.remove('is-active'); });
            swatch.classList.add('is-active');
          });
        });

        // Restore default state when mouse leaves the swatches container
        if (swatchesContainer) {
          swatchesContainer.addEventListener('mouseleave', restoreDefaultState);
        }
      }

      // Also restore when mouse leaves the whole card
      card.addEventListener('mouseleave', restoreDefaultState);

      // 3. Wishlist button click listener
      if (wishlistBtn) {
        wishlistBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          handleWishlistToggle(wishlistBtn, card);
        });
      }
    });

    // Quick view click listener
    var quickBtns = scope.querySelectorAll('.gtech-instant-card__quickview-button');
    quickBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        handleQuickViewClick(btn);
      });
    });
  }

  function ensureQuickViewModal() {
    var modal = document.getElementById(quickViewModalId);
    if (modal) {
      if (!modal.modalContent) {
        modal.modalContent = modal.querySelector('[id^="QuickAddInfo-"]');
      }
      return modal;
    }
    modal = document.createElement("quick-add-modal");
    modal.id = quickViewModalId;
    modal.className = "quick-add-modal hidden gtech-instant-quickadd-modal";
    modal.innerHTML =
      '<div class="overlay-quick-modal"></div>' +
      '<div role="dialog" aria-label="Quick view" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">' +
      '<button id="ModalClose-gtech-typesense" type="button" class="quick-add-modal__toggle" aria-label="Close">' +
      '<span aria-hidden="true" class="icon px-4" data-icon="close-hco" data-testid="icon"></span>' +
      '</button>' +
      '<div id="' + quickViewInfoId + '" class="quick-add-modal__content-info"></div>' +
      '</div>';
    modal.modalContent = modal.querySelector('[id^="QuickAddInfo-"]');

    function closeModal() {
      if (typeof modal.hide === "function") {
        modal.hide(false);
      } else {
        modal.classList.add("hidden");
        modal.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
      }
    }

    var closeBtn = modal.querySelector('.quick-add-modal__toggle');
    var overlay = modal.querySelector('.overlay-quick-modal');
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (overlay) overlay.addEventListener("click", closeModal);

    document.body.appendChild(modal);
    return modal;
  }

  function handleQuickViewClick(btn) {
    if (!btn) return;
    ensureQuickViewModal();
    var modal = document.getElementById(quickViewModalId);
    if (modal) {
      if (typeof modal.show === "function") {
        modal.show(btn);
      } else {
        var handle = btn.getAttribute('data-product-handle') || '';
        var variantId = btn.getAttribute('data-variant-id') || '';
        var productUrl = btn.getAttribute('data-product-url') || ('/products/' + handle);
        openQuickViewFallback(modal, productUrl, variantId, btn);
      }
    }
  }

  function openQuickViewFallback(modal, productUrl, variantId, btn) {
    var infoContainer = document.getElementById(quickViewInfoId);
    if (infoContainer) {
      infoContainer.innerHTML = '<div style="padding:40px; text-align:center; font-size:14px; color:#6b7280;">' + escapeAttr(t('loading_product_details', 'Loading product details...')) + '</div>';
    }
    if (btn) {
      btn.classList.add('loading');
    }
    modal.classList.remove('hidden');
    modal.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');

    var fetchUrl = productUrl + (productUrl.includes('?') ? '&' : '?') + 'view=quick-add' + (variantId ? '&variant=' + variantId : '');
    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        if (btn) btn.classList.remove('loading');
        if (infoContainer) {
          infoContainer.innerHTML = html;
          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }
        }
      })
      .catch(function () {
        if (btn) btn.classList.remove('loading');
        if (infoContainer) {
          infoContainer.innerHTML = '<div style="padding:40px; text-align:center; color:#e11d48;">' + escapeAttr(t('failed_to_load_product_details', 'Failed to load product details.')) + '</div>';
        }
      });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".gtech-instant-card__quickview-button");
    if (btn) {
      e.stopPropagation();
      e.preventDefault();
      handleQuickViewClick(btn);
    }
  }, { capture: true });

  function initQuickAddModalListeners() {
    ensureQuickViewModal();
  }

  function getNavTree() {
    var raw = window.GTECH_TYPESENSE_CONTEXT && window.GTECH_TYPESENSE_CONTEXT.collectionNavTree;
    if (!raw) return null;
    if (typeof raw === 'string') {
      try {
        var parsed = JSON.parse(raw);
        if (typeof parsed === 'string') {
          parsed = JSON.parse(parsed);
        }
        return parsed;
      } catch (e) {
        return null;
      }
    }
    return raw;
  }

  function renderCollectionNavTree(currentRoot) {
    if (!currentRoot) return;
    var navTree = getNavTree();
    if (!navTree || !navTree.groups || !Array.isArray(navTree.groups) || navTree.groups.length === 0) return;

    var currentHandle = (window.GTECH_TYPESENSE_CONTEXT && window.GTECH_TYPESENSE_CONTEXT.collectionHandle) || '';
    if (!currentHandle && window.location.pathname.includes('/collections/')) {
      var segs = window.location.pathname.split('/collections/')[1].split('/')[0].split('?')[0];
      currentHandle = segs;
    }

    // 1. Mobile Drawer Collection Panel
    var drawerBody = currentRoot.querySelector('[data-gtech-instant-facets]');
    if (drawerBody) {
      var existingPanel = drawerBody.querySelector('.gtech-instant__collection-panel');
      if (existingPanel) existingPanel.remove();

      var panelWrap = document.createElement('div');
      panelWrap.className = 'gtech-instant__collection-panel gtech-instant__sidebar-menu--mobile';
      panelWrap.setAttribute('data-gtech-instant-panel', 'collection-nav');
      panelWrap.setAttribute('data-panel-active', 'true');

      var treeHtml = '<div class="gtech-instant__collection-panel-tree">';

      navTree.groups.forEach(function (group) {
        var hasSubItems = Array.isArray(group.items) && group.items.length > 0;
        if (hasSubItems) {
          treeHtml += '<details class="gtech-instant__collection-panel-group" open>';
          treeHtml += '<summary class="gtech-instant__collection-panel-summary">';
          treeHtml += '<span>' + escapeAttr(group.title) + '</span>';
          treeHtml += '<span class="gtech-instant__collection-panel-chevron" aria-hidden="true"></span>';
          treeHtml += '</summary>';
          treeHtml += '<ul class="gtech-instant__collection-panel-list">';

          group.items.forEach(function (sub) {
            var subLabel = sub.label || sub.title || '';
            var subHandle = sub.handle || '';
            var subUrl = sub.url || ('/collections/' + subHandle);
            var isCur = subHandle && subHandle === currentHandle;
            treeHtml += '<li class="gtech-instant__collection-panel-item">';
            treeHtml += '<a href="' + escapeAttr(subUrl) + '" class="gtech-instant__collection-panel-link' + (isCur ? ' is-featured' : '') + '">' + escapeAttr(subLabel) + '</a>';
            treeHtml += '</li>';
          });

          treeHtml += '</ul>';
          treeHtml += '</details>';
        } else {
          var gTitle = group.title || '';
          var gHandle = group.handle || '';
          var gUrl = group.url || ('/collections/' + gHandle);
          var isCur = gHandle && gHandle === currentHandle;
          treeHtml += '<a href="' + escapeAttr(gUrl) + '" class="gtech-instant__collection-panel-group-link' + (isCur ? ' is-featured' : '') + '">';
          treeHtml += '<span>' + escapeAttr(gTitle) + '</span>';
          treeHtml += '</a>';
        }
      });

      treeHtml += '</div>';
      panelWrap.innerHTML = treeHtml;
      drawerBody.appendChild(panelWrap);
    }

    // 2. Desktop Sidebar Menu (if not already rendered by Liquid)
    var sidebar = currentRoot.querySelector('[data-gtech-instant-sidebar-facets]');
    if (sidebar) {
      var existingSidebarMenu = sidebar.querySelector('.gtech-instant__sidebar-menu--desktop');
      if (!existingSidebarMenu) {
        var sideWrap = document.createElement('div');
        sideWrap.className = 'gtech-instant__sidebar-menu gtech-instant__sidebar-menu--desktop';
        var sideHtml = '<h3 class="gtech-instant__sidebar-menu-title">' + escapeAttr(navTree.title || 'Category') + '</h3>';
        sideHtml += '<ul class="gtech-instant__sidebar-menu-list">';

        navTree.groups.forEach(function (group) {
          var hasSubItems = Array.isArray(group.items) && group.items.length > 0;
          if (hasSubItems) {
            sideHtml += '<li class="gtech-instant__sidebar-menu-item is-active">';
            sideHtml += '<details class="gtech-instant__sidebar-menu-details" open>';
            sideHtml += '<summary class="gtech-instant__sidebar-menu-summary">';
            sideHtml += '<a href="' + escapeAttr(group.url || ('/collections/' + group.handle)) + '" class="gtech-instant__sidebar-menu-link">' + escapeAttr(group.title) + '</a>';
            sideHtml += '<span class="gtech-instant__sidebar-menu-chevron" aria-hidden="true">';
            sideHtml += '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-caret"><path d="M9 1L5 5L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            sideHtml += '</span>';
            sideHtml += '</summary>';
            sideHtml += '<ul class="gtech-instant__sidebar-menu-sublist">';

            group.items.forEach(function (sub) {
              var subLabel = sub.label || sub.title || '';
              var subHandle = sub.handle || '';
              var subUrl = sub.url || ('/collections/' + subHandle);
              var isCur = subHandle && subHandle === currentHandle;
              sideHtml += '<li class="gtech-instant__sidebar-menu-subitem' + (isCur ? ' is-active' : '') + '">';
              sideHtml += '<a href="' + escapeAttr(subUrl) + '" class="gtech-instant__sidebar-menu-sublink">' + escapeAttr(subLabel) + '</a>';
              sideHtml += '</li>';
            });

            sideHtml += '</ul>';
            sideHtml += '</details>';
            sideHtml += '</li>';
          } else {
            var gTitle = group.title || '';
            var gHandle = group.handle || '';
            var gUrl = group.url || ('/collections/' + gHandle);
            var isCur = gHandle && gHandle === currentHandle;
            sideHtml += '<li class="gtech-instant__sidebar-menu-item' + (isCur ? ' is-active' : '') + '">';
            sideHtml += '<a href="' + escapeAttr(gUrl) + '" class="gtech-instant__sidebar-menu-link">' + escapeAttr(gTitle) + '</a>';
            sideHtml += '</li>';
          }
        });

        sideHtml += '</ul>';
        sideWrap.innerHTML = sideHtml;
        sidebar.insertBefore(sideWrap, sidebar.firstChild);
      }
    }
  }

  function openDrawer(panel) {
    var currentRoot = root || document.querySelector('[data-gtech-typesense-root]') || document.querySelector('.section-gtech-typesense');
    if (!currentRoot) return;
    var activePanel = panel || 'all';
    var drawer = currentRoot.querySelector('[data-gtech-instant-drawer]');
    var titleEl = currentRoot.querySelector('[data-gtech-instant-drawer-title]');
    var overlay = currentRoot.querySelector('.gtech-instant__drawer-overlay');

    if (activePanel === 'collection-nav') {
      renderCollectionNavTree(currentRoot);
    }

    currentRoot.classList.add('is-drawer-open');
    currentRoot.setAttribute('data-active-panel', activePanel);
    if (drawer) {
      drawer.setAttribute('data-active-panel', activePanel);
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
    }
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('gtech-instant-drawer-open');

    if (titleEl) {
      if (activePanel === 'all') {
        titleEl.textContent = t('filter_and_sort', 'Filter & Sort');
      } else if (activePanel === 'collection-nav') {
        var collectionBtn = currentRoot.querySelector('[data-gtech-instant-nav] .gtech-instant__chip--collection span:first-child');
        var colTitle = '';
        if (collectionBtn) {
          colTitle = collectionBtn.getAttribute('data-base-title') || collectionBtn.textContent.replace(/\s*\(\d[\d,.]*\)\s*$/, '').trim();
        }
        if (!colTitle && window.GTECH_TYPESENSE_CONTEXT && window.GTECH_TYPESENSE_CONTEXT.collectionTitle) {
          colTitle = window.GTECH_TYPESENSE_CONTEXT.collectionTitle;
        }
        titleEl.textContent = colTitle || t('categories', 'Categories');
      } else {
        var facetMap = {
          category_group: t('category', 'Category'),
          category_name: t('category', 'Category'),
          category_facet: t('category', 'Category'),
          base_color: t('color', 'Color'),
          available_sizes: t('size', 'Size'),
          length: t('length', 'Length'),
          collection_rises: t('rise', 'Rise'),
          collection_styles: t('style', 'Style'),
          necklines: t('neckline', 'Neckline'),
          product_type: t('product_type', 'Product Type'),
          vendor: t('vendor', 'Vendor')
        };
        titleEl.textContent = facetMap[activePanel] || t('filter_and_sort', 'Filter & Sort');
      }
    }

    var facetPanels = currentRoot.querySelectorAll('.gtech-instant__facet, .gtech-instant__collection-panel, .gtech-instant__sidebar-menu--mobile');
    facetPanels.forEach(function (panelEl) {
      var panelAttr = panelEl.getAttribute('data-gtech-instant-panel');
      var isCategoryNav = (panelAttr === 'collection-nav' || panelEl.classList.contains('gtech-instant__collection-panel'));
      var isTarget = false;
      if (isCategoryNav) {
        isTarget = (activePanel === 'collection-nav');
      } else {
        isTarget = (activePanel === 'all' || panelAttr === activePanel);
      }
      panelEl.setAttribute('data-panel-active', isTarget ? 'true' : 'false');
      if (activePanel === 'all') {
        // Default accordions collapsed in Filter & Sort mode
        panelEl.setAttribute('data-accordion-open', 'false');
        var toggle = panelEl.querySelector('[data-gtech-facet-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      } else if (isTarget) {
        // Open single target panel
        panelEl.setAttribute('data-accordion-open', 'true');
        var targetToggle = panelEl.querySelector('[data-gtech-facet-toggle]');
        if (targetToggle) targetToggle.setAttribute('aria-expanded', 'true');
      }
    });

    updateDrawerResultCount(currentRoot);
    groupCategoryFacetInDOM(currentRoot);
  }

  function closeDrawer() {
    var currentRoot = root || document.querySelector('[data-gtech-typesense-root]') || document.querySelector('.section-gtech-typesense');
    if (!currentRoot) return;
    var drawer = currentRoot.querySelector('[data-gtech-instant-drawer]');
    var overlay = currentRoot.querySelector('.gtech-instant__drawer-overlay');
    currentRoot.classList.remove('is-drawer-open');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
    }
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('gtech-instant-drawer-open');
  }

  function toggleFacetAccordion(button) {
    var panel = button && button.closest('.gtech-instant__facet');
    if (!panel) return;
    var isOpen = panel.getAttribute('data-accordion-open') === 'true';
    panel.setAttribute('data-accordion-open', isOpen ? 'false' : 'true');
    button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    var currentRoot = button.closest('[data-gtech-typesense-root]') || root;
    if (currentRoot) groupCategoryFacetInDOM(currentRoot);
  }

  function updateDrawerResultCount(currentRoot) {
    var countNode = (currentRoot || root || document).querySelector('[data-gtech-instant-show-count]');
    var drawerCountText = (currentRoot || root || document).querySelector('[data-gtech-instant-drawer-count]');
    var count = null;
    if (searchInstance && searchInstance.helper && searchInstance.helper.lastResults) {
      count = searchInstance.helper.lastResults.nbHits;
    }
    if (count == null) {
      var statsText = (currentRoot || root || document).querySelector('.ais-Stats-text');
      if (statsText) {
        var match = statsText.textContent.match(/[\d,.]+/);
        if (match) count = parseInt(match[0].replace(/[^\d]/g, ''), 10);
      }
    }
    var drawer = (currentRoot || root || document).querySelector('[data-gtech-instant-drawer]');
    var isAll = !drawer || drawer.getAttribute('data-active-panel') === 'all';
    var resWord = (count === 1) ? t('results_singular', 'Result') : t('results', 'Results');
    var countLabel = (count != null && !isNaN(count))
      ? (count === 1 ? '1 ' + resWord : count.toLocaleString('id-ID') + ' ' + resWord)
      : '0 ' + resWord;

    if (drawerCountText) {
      drawerCountText.textContent = countLabel;
    }
    if (countNode) {
      var showTpl = t('show_results', 'Show {count}');
      countNode.textContent = isAll ? t('done', 'Done') : showTpl.replace('{count}', countLabel);
    }
    var collectionChip = (currentRoot || root || document).querySelector('.gtech-instant__chip--collection span:first-child');
    if (collectionChip && isSearchPage()) {
      collectionChip.textContent = t('search_results', 'Search Results');
    }
  }

  var drawerEventsInitialized = false;
  function initDrawerEvents() {
    if (drawerEventsInitialized) return;
    drawerEventsInitialized = true;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-gtech-instant-open-panel]');
      if (opener) {
        e.preventDefault();
        e.stopPropagation();
        var targetPanel = opener.getAttribute('data-gtech-instant-open-panel') || 'all';
        openDrawer(targetPanel);
        return;
      }

      var closer = e.target.closest('[data-gtech-instant-close-panel], .gtech-instant__drawer-overlay');
      if (closer) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
        return;
      }

      var clearBtn = e.target.closest('[data-gtech-instant-drawer-clear]');
      if (clearBtn) {
        e.preventDefault();
        e.stopPropagation();
        if (searchInstance && searchInstance.helper) {
          var drawer = document.querySelector('[data-gtech-instant-drawer]');
          var activePanel = drawer ? drawer.getAttribute('data-active-panel') : 'all';
          if (activePanel && activePanel !== 'all' && activePanel !== 'collection-nav') {
            searchInstance.helper.clearRefinements(activePanel).search();
          } else {
            searchInstance.helper.clearRefinements().search();
          }
        }
        return;
      }

      var facetToggle = e.target.closest('[data-gtech-facet-toggle]');
      if (facetToggle) {
        e.preventDefault();
        e.stopPropagation();
        toggleFacetAccordion(facetToggle);
        return;
      }

      var sortShell = e.target.closest('[data-gtech-instant-sort-drawer-shell]');
      if (sortShell && !e.target.matches('select')) {
        var sel = sortShell.querySelector('select');
        if (sel) {
          sel.focus();
          if (typeof sel.showPicker === 'function') {
            try { sel.showPicker(); } catch (err) {}
          }
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  function initFilterbarDragScroll(currentRoot) {
    var filterbars = (currentRoot || root || document).querySelectorAll('.gtech-instant__filterbar');
    filterbars.forEach(function (filterbar) {
      if (filterbar.__hasDragScroll) return;
      filterbar.__hasDragScroll = true;

      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var hasMoved = false;

      filterbar.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return;
        isDown = true;
        hasMoved = false;
        startX = e.pageX - filterbar.offsetLeft;
        scrollLeft = filterbar.scrollLeft;
      });

      window.addEventListener('mouseup', function () {
        if (!isDown) return;
        isDown = false;
        if (filterbar.classList.contains('is-dragging')) {
          setTimeout(function () {
            filterbar.classList.remove('is-dragging');
            hasMoved = false;
          }, 60);
        }
      });

      filterbar.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var x = e.pageX - filterbar.offsetLeft;
        var walk = x - startX;
        if (Math.abs(walk) > 4) {
          hasMoved = true;
          filterbar.classList.add('is-dragging');
          e.preventDefault();
          filterbar.scrollLeft = scrollLeft - walk;
        }
      });

      filterbar.addEventListener('click', function (e) {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
          hasMoved = false;
        }
      }, true);
    });
  }

  function updateFilterChipCounts(currentRoot) {
    if (!currentRoot || !searchInstance || !searchInstance.helper) return;
    var helper = searchInstance.helper;
    var disjunctive = helper.state.disjunctiveFacetsRefinements || {};
    var hierarchical = helper.state.hierarchicalFacetsRefinements || {};
    var conjunctive = helper.state.facetsRefinements || {};

    var totalActive = 0;
    var activeByFacet = {};
    var activeItemsByFacet = {};

    Object.keys(disjunctive).forEach(function (attr) {
      var items = disjunctive[attr] || [];
      if (items.length > 0) {
        activeItemsByFacet[attr] = items;
        activeByFacet[attr] = (activeByFacet[attr] || 0) + items.length;
        totalActive += items.length;
      }
    });
    Object.keys(conjunctive).forEach(function (attr) {
      var items = conjunctive[attr] || [];
      if (items.length > 0) {
        activeItemsByFacet[attr] = (activeItemsByFacet[attr] || []).concat(items);
        activeByFacet[attr] = (activeByFacet[attr] || 0) + items.length;
        totalActive += items.length;
      }
    });
    Object.keys(hierarchical).forEach(function (attr) {
      var items = hierarchical[attr] || [];
      if (items.length > 0) {
        var cleanItems = items.map(function(item) {
          var parts = item.split(' > ');
          return parts[parts.length - 1];
        });
        activeItemsByFacet[attr] = (activeItemsByFacet[attr] || []).concat(cleanItems);
        activeByFacet[attr] = (activeByFacet[attr] || 0) + items.length;
        totalActive += items.length;
      }
    });

    // Update Filter & Sort button text e.g. "Filter & Sort (1)"
    var filterBtn = currentRoot.querySelector('.gtech-instant__chip--filter span:last-child');
    if (filterBtn) {
      var filterBase = t('filter_and_sort', 'Filter & Sort');
      filterBtn.textContent = totalActive > 0 ? filterBase + ' (' + totalActive + ')' : filterBase;
    }

    // Update individual facet chips e.g. "Size: (1)"
    var facetMap = {
      category_group: t('category', 'Category'),
      category_name: t('category', 'Category'),
      category_facet: t('category', 'Category'),
      base_color: t('color', 'Color'),
      available_sizes: t('size', 'Size'),
      length: t('length', 'Length'),
      collection_rises: t('rise', 'Rise'),
      collection_styles: t('style', 'Style'),
      necklines: t('neckline', 'Neckline'),
      product_type: t('product_type', 'Product Type'),
      vendor: t('vendor', 'Vendor')
    };

    var chips = currentRoot.querySelectorAll('[data-gtech-instant-facet-chip]');
    chips.forEach(function (chip) {
      var attr = chip.getAttribute('data-gtech-instant-facet-chip');
      var label = facetMap[attr] || chip.getAttribute('data-gtech-facet-label') || chip.textContent.replace(/:\s*\(\d+\)/, '').trim();
      chip.setAttribute('data-gtech-facet-label', label);
      var count = activeByFacet[attr] || 0;
      var span = chip.querySelector('span') || chip;
      span.textContent = count > 0 ? label + ': (' + count + ')' : label;
    });

    // Update subtitle for each facet toggle in drawer (e.g. "Size" -> "XL", "Category" -> "Sleepwear")
    Object.keys(facetMap).forEach(function (attr) {
      var subtitleEl = currentRoot.querySelector('[data-gtech-facet-subtitle="' + attr + '"]');
      if (subtitleEl) {
        var items = activeItemsByFacet[attr] || [];
        subtitleEl.textContent = items.join(', ');
        subtitleEl.style.display = items.length > 0 ? 'block' : 'none';
      }
    });

    // Ensure Collection Title chip displays plain title without count (e.g. "All Men's")
    var collectionBtn = currentRoot.querySelector('[data-gtech-instant-nav] .gtech-instant__chip--collection span:first-child');
    if (collectionBtn) {
      var rawTitle = collectionBtn.getAttribute('data-base-title');
      if (!rawTitle) {
        rawTitle = collectionBtn.textContent.replace(/\s*\(\d[\d,.]*\)\s*$/, '').trim();
        collectionBtn.setAttribute('data-base-title', rawTitle);
      }
      collectionBtn.textContent = rawTitle;
    }

    // Toggle active row display if active filters exist
    var activeRow = currentRoot.querySelector('[data-gtech-instant-active-row]');
    if (activeRow) {
      activeRow.style.display = totalActive > 0 ? 'flex' : 'none';
    }
  }

  function syncFilterbarChips(currentRoot, facetList) {
    if (!currentRoot) return;
    var filterbar = currentRoot.querySelector('.gtech-instant__filterbar');
    if (!filterbar) return;
    var stats = currentRoot.querySelector('[data-gtech-instant-stats]');

    var existingChips = filterbar.querySelectorAll('.gtech-instant__chip:not(.gtech-instant__chip--collection):not(.gtech-instant__chip--filter)');
    existingChips.forEach(function (el) { el.parentNode.removeChild(el); });

    facetList.forEach(function (facet) {
      var chip = document.createElement('button');
      chip.className = 'gtech-instant__chip';
      chip.type = 'button';
      chip.setAttribute('data-gtech-instant-open-panel', facet.attribute);
      chip.setAttribute('data-gtech-instant-facet-chip', facet.attribute);
      chip.setAttribute('data-gtech-facet-label', facet.label);
      chip.innerHTML = '<span>' + escapeAttr(facet.label) + '</span>';
      filterbar.insertBefore(chip, stats || null);
    });
  }

  function createFacetAccordionMarkup(attribute, label, isDrawer, baseAttr) {
    if (isDrawer) {
      var attrKey = baseAttr || attribute.replace(/-mobile$/, '');
      return (
        '<button class="gtech-instant__facet-toggle" type="button" data-gtech-facet-toggle="' + escapeAttr(attribute) + '" aria-expanded="false">' +
          '<div class="gtech-instant__facet-toggle-text">' +
            '<span class="gtech-instant__facet-title">' + escapeAttr(label) + '</span>' +
            '<span class="gtech-instant__facet-subtitle" data-gtech-facet-subtitle="' + escapeAttr(attrKey) + '" style="display:none;"></span>' +
          '</div>' +
          '<span class="gtech-instant__facet-toggle-icon" aria-hidden="true"></span>' +
        '</button>' +
        '<div class="gtech-instant__facet-content" id="typesense-facet-' + attribute + '"></div>'
      );
    }
    return (
      '<details class="gtech-instant__facet-details" open data-accordion-open="true">' +
        '<summary class="gtech-instant__facet-summary">' +
          '<span class="gtech-instant__facet-title">' + escapeAttr(label) + '</span>' +
          '<span class="gtech-instant__facet-chevron" aria-hidden="true">' +
            '<svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-caret">' +
              '<path d="M9 1L5 5L1 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</span>' +
        '</summary>' +
        '<div class="gtech-instant__facet-body" id="typesense-facet-' + attribute + '"></div>' +
      '</details>'
    );
  }

  var mobileCategoryDropdownInitialized = false;
  function initMobileCategoryDropdown() {
    if (mobileCategoryDropdownInitialized) return;
    mobileCategoryDropdownInitialized = true;

    document.addEventListener('click', function (e) {
      var selectBtn = e.target.closest('.gtech-instant__mobile-category-select');
      if (selectBtn) {
        e.preventDefault();
        e.stopPropagation();
        var wrap = selectBtn.closest('.gtech-instant__mobile-category-wrap');
        if (wrap) {
          var isOpen = wrap.classList.toggle('is-open');
          selectBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
        return;
      }

      var openWraps = document.querySelectorAll('.gtech-instant__mobile-category-wrap.is-open');
      openWraps.forEach(function (wrap) {
        if (!e.target.closest('.gtech-instant__mobile-category-wrap')) {
          wrap.classList.remove('is-open');
          var btn = wrap.querySelector('.gtech-instant__mobile-category-select');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  function createPromoBannerElement(banner) {
    var span = String(banner.column_span || '2');
    var spanMobile = String(banner.column_span_mobile || '2');
    var mediaType = banner.media_type || 'image';
    var imgUrl = banner.image_url || '';
    var vidUrl = banner.video_url || '';
    var heading = banner.heading || '';
    var subheading = banner.subheading || '';
    var textAlign = banner.text_align || 'bottom-left';
    var textColor = banner.text_color || '#ffffff';
    var overlayOpacity = Number(banner.overlay_opacity);
    if (isNaN(overlayOpacity)) overlayOpacity = 20;
    var opacityVal = (overlayOpacity / 100).toFixed(2);

    var btn1Text = banner.btn_1_text || '';
    var btn1Url = banner.btn_1_url || '';
    var btn2Text = banner.btn_2_text || '';
    var btn2Url = banner.btn_2_url || '';
    var cardLink = banner.card_link || '';

    var bannerEl = document.createElement('li');
    bannerEl.className = 'ais-Hits-item gtech-instant-promo-card gtech-instant-promo-card--span-' + span + ' gtech-instant-promo-card--span-mobile-' + spanMobile + ' gtech-instant-promo-card--align-' + textAlign;
    bannerEl.setAttribute('data-promo-banner-id', banner.id || '');

    var mediaHtml = '';
    if (mediaType === 'video' && vidUrl) {
      mediaHtml = '<video class="gtech-instant-promo-card__media" autoplay loop muted playsinline webkit-playsinline preload="auto" src="' + escapeAttr(vidUrl) + '"></video>';
    } else if (imgUrl) {
      mediaHtml = '<img class="gtech-instant-promo-card__media" src="' + escapeAttr(imgUrl) + '" alt="' + escapeAttr(heading || subheading || 'Promotion') + '" loading="lazy" />';
    }

    var buttonsHtml = '';
    if (btn1Text && btn1Url) {
      buttonsHtml += '<a href="' + escapeAttr(btn1Url) + '" class="gtech-instant-promo-card__btn">' + escapeAttr(btn1Text) + '</a>';
    }
    if (btn2Text && btn2Url) {
      buttonsHtml += '<a href="' + escapeAttr(btn2Url) + '" class="gtech-instant-promo-card__btn">' + escapeAttr(btn2Text) + '</a>';
    }

    var contentHtml =
      '<div class="gtech-instant-promo-card__inner">' +
        mediaHtml +
        '<div class="gtech-instant-promo-card__overlay" style="background: rgba(0,0,0,' + opacityVal + ');"></div>' +
        '<div class="gtech-instant-promo-card__content" style="color:' + escapeAttr(textColor) + ';">' +
          (subheading ? '<p class="gtech-instant-promo-card__subheading">' + escapeAttr(subheading) + '</p>' : '') +
          (heading ? '<h3 class="gtech-instant-promo-card__heading">' + escapeAttr(heading) + '</h3>' : '') +
          (buttonsHtml ? '<div class="gtech-instant-promo-card__actions">' + buttonsHtml + '</div>' : '') +
        '</div>' +
      '</div>';

    if (cardLink && !buttonsHtml) {
      bannerEl.innerHTML = '<a href="' + escapeAttr(cardLink) + '" class="gtech-instant-promo-card__link-wrap">' + contentHtml + '</a>';
    } else {
      bannerEl.innerHTML = contentHtml;
    }

    return bannerEl;
  }

  function renderGridPromoBanners(currentRoot) {
    if (!currentRoot) return;
    var hitsList = currentRoot.querySelector('.ais-Hits-list');
    if (!hitsList) return;

    // Remove previously inserted promo banners before re-injecting
    var existingBanners = hitsList.querySelectorAll('.gtech-instant-promo-card');
    existingBanners.forEach(function (el) {
      el.remove();
    });

    var scriptEl = currentRoot.querySelector('[data-gtech-instant-grid-banners]');
    if (!scriptEl) return;

    var bannersData = [];
    try {
      bannersData = JSON.parse(scriptEl.textContent || '[]');
    } catch (err) {
      console.warn('⚠️ [GTECH TYPESENSE] Failed to parse grid banners JSON:', err);
      return;
    }

    if (!Array.isArray(bannersData) || bannersData.length === 0) return;

    var currentCollectionHandle = currentRoot.getAttribute('data-collection-handle') || '';
    if (!currentCollectionHandle && window.GTECH_TYPESENSE_CONTEXT && window.GTECH_TYPESENSE_CONTEXT.collectionHandle) {
      currentCollectionHandle = window.GTECH_TYPESENSE_CONTEXT.collectionHandle;
    }

    // Filter banners for current collection and sort by position ascending
    var matchingBanners = bannersData.filter(function (banner) {
      if (!banner) return false;
      var targetCol = String(banner.target_collection || '').trim();
      if (!targetCol) return true; // Empty target_collection displays on all collections
      return targetCol === currentCollectionHandle;
    }).sort(function (a, b) {
      return (Number(a.position) || 0) - (Number(b.position) || 0);
    });

    if (matchingBanners.length === 0) return;

    // Determine current page (0-indexed and 1-indexed)
    var currentPage = 0;
    if (searchInstance && searchInstance.helper && typeof searchInstance.helper.getPage === 'function') {
      currentPage = searchInstance.helper.getPage() || 0;
    } else if (searchInstance && searchInstance.helper && searchInstance.helper.state && typeof searchInstance.helper.state.page === 'number') {
      currentPage = searchInstance.helper.state.page || 0;
    }
    var pageNumber = currentPage + 1;

    matchingBanners.forEach(function (banner) {
      var repeatMode = banner.repeat_mode || 'first_page';
      var targetPage = parseInt(banner.target_page, 10) || 1;
      var pos = parseInt(banner.position, 10);
      if (isNaN(pos) || pos < 1) pos = 1;

      // 1. First page only mode: only show on page 1 (0-indexed: 0)
      if (repeatMode === 'first_page' && currentPage !== 0) {
        return;
      }

      // 2. Specific page mode: only show on targetPage
      if (repeatMode === 'specific_page' && pageNumber !== targetPage) {
        return;
      }

      // 3. Repeating interval mode (e.g. repeat every N cards in grid)
      if (repeatMode === 'repeating_interval') {
        var interval = parseInt(banner.repeat_interval, 10);
        if (isNaN(interval) || interval < 1) interval = pos || 5;

        var productCards = Array.from(hitsList.querySelectorAll('.ais-Hits-item:not(.gtech-instant-promo-card)'));
        if (productCards.length === 0) return;

        var currentCardTarget = pos;
        while (currentCardTarget <= productCards.length) {
          var bannerEl = createPromoBannerElement(banner);
          var refProduct = productCards[currentCardTarget - 1];
          if (refProduct && refProduct.parentNode === hitsList) {
            hitsList.insertBefore(bannerEl, refProduct);
          } else {
            hitsList.appendChild(bannerEl);
          }
          currentCardTarget += interval;
        }
      } else {
        // 'first_page', 'every_page', or 'specific_page'
        var bannerEl = createPromoBannerElement(banner);
        var productCards = Array.from(hitsList.querySelectorAll('.ais-Hits-item:not(.gtech-instant-promo-card)'));
        var targetIndex = pos - 1;

        if (productCards.length === 0) {
          hitsList.appendChild(bannerEl);
        } else if (targetIndex >= productCards.length) {
          hitsList.appendChild(bannerEl);
        } else {
          var refProduct = productCards[targetIndex];
          hitsList.insertBefore(bannerEl, refProduct);
        }
      }
    });
  }

  function interleaveHitsByProduct(hits) {
    if (!hits || !Array.isArray(hits) || hits.length <= 1) return hits;

    try {
      // Check if user has chosen a price sort
      var isPriceSort = false;
      if (searchInstance && searchInstance.helper && searchInstance.helper.state && searchInstance.helper.state.index) {
        var currentIndex = String(searchInstance.helper.state.index || '');
        if (currentIndex.indexOf('price:') !== -1) {
          isPriceSort = true;
        }
      }
      if (isPriceSort) {
        return hits;
      }

      // Group hits by parent product identifier
      var groups = [];
      var groupMap = {};

      hits.forEach(function (hit) {
        if (!hit) return;
        var key = hit.product_id || hit.style_key || (hit.title ? hit.title.toLowerCase().trim() : hit.id);
        if (!groupMap[key]) {
          groupMap[key] = [];
          groups.push(groupMap[key]);
        }
        groupMap[key].push(hit);
      });

      // Interleave across groups so colorways of the same product are spread out nicely
      var result = [];
      var maxGroupLen = 0;
      groups.forEach(function (g) {
        if (g.length > maxGroupLen) maxGroupLen = g.length;
      });

      for (var i = 0; i < maxGroupLen; i++) {
        for (var g = 0; g < groups.length; g++) {
          if (i < groups[g].length) {
            result.push(groups[g][i]);
          }
        }
      }

      return result;
    } catch (err) {
      console.error('⚠️ [GTECH TYPESENSE] Error interleaving hits:', err);
      return hits;
    }
  }

  function initTypesenseEngine() {
    console.log('⚡ [GTECH TYPESENSE] initTypesenseEngine triggered');
    root = document.querySelector('[data-gtech-typesense-root]') || document.querySelector('.section-gtech-typesense');
    if (!root) {
      console.warn('⚠️ [GTECH TYPESENSE] Root element NOT found in DOM. (Query: [data-gtech-typesense-root] or .section-gtech-typesense)');
      return;
    }
    console.log('✅ [GTECH TYPESENSE] Root element found:', root);

    var layout = root.getAttribute('data-section-layout') || root.getAttribute('data-gtech-instant-layout') || 'normal';
    root.setAttribute('data-gtech-instant-layout', layout);
    root.setAttribute('data-section-layout', layout);

    if (typeof window.TypesenseInstantSearchAdapter === 'undefined' || typeof window.instantsearch === 'undefined') {
      console.warn('⏳ [GTECH TYPESENSE] Waiting for dependencies: TypesenseInstantSearchAdapter =', typeof window.TypesenseInstantSearchAdapter, ', instantsearch =', typeof window.instantsearch);
      setTimeout(initTypesenseEngine, 100);
      return;
    }
    console.log('✅ [GTECH TYPESENSE] Dependencies loaded!');

    // Cleanup previous search instance if re-initializing in Shopify Theme Editor
    if (searchInstance && typeof searchInstance.dispose === 'function') {
      try {
        console.log('🧹 [GTECH TYPESENSE] Disposing previous searchInstance...');
        searchInstance.dispose();
      } catch (dispErr) {
        console.warn('⚠️ [GTECH TYPESENSE] Error disposing previous instance:', dispErr);
      }
      searchInstance = null;
    }

    // Clean up dynamically appended facet containers before re-adding
    var prevDesktopSidebar = root.querySelector('[data-gtech-instant-sidebar-facets]');
    if (prevDesktopSidebar) {
      prevDesktopSidebar.querySelectorAll('.gtech-instant__facet').forEach(function (el) { el.remove(); });
    }
    var prevMobileDrawer = root.querySelector('[data-gtech-instant-facets]');
    var prevMobileWrapper = (prevMobileDrawer && prevMobileDrawer.querySelector('[data-gtech-instant-facets-wrapper]')) || prevMobileDrawer;
    if (prevMobileWrapper) {
      prevMobileWrapper.querySelectorAll('.gtech-instant__facet').forEach(function (el) { el.remove(); });
    }

    var nodesList = Array.isArray(window.GTECH_TYPESENSE_NODES) && window.GTECH_TYPESENSE_NODES.length > 0
      ? window.GTECH_TYPESENSE_NODES
      : [
          { host: HOST, port: PORT, protocol: PROTOCOL }
        ];

    var displayMode = (context().displayMode || root.getAttribute('data-display-mode') || 'color').toLowerCase().trim();
    var hitsPerPageVal = parseInt(context().hitsPerPage || root.getAttribute('data-hits-per-page') || '36', 10) || 36;

    var collectionHandle = context().collectionHandle || root.getAttribute('data-collection-handle') || '';
    var collectionId = context().collectionId || root.getAttribute('data-collection-id') || '';
    var cleanColHandle = String(collectionHandle || '').toLowerCase().replace(/[^a-z0-9_]/g, '_');

    var additionalParams = {
      query_by: 'title,color_label,base_color,tags,product_type,vendor'
    };
    if (displayMode === 'parent') {
      additionalParams.group_by = 'product_id';
      additionalParams.group_limit = 1;
    }
    if (isSearchPage()) {
      additionalParams.sort_by = 'inventory_available:desc,_text_match:desc,published_at_ts:desc';
    } else if (cleanColHandle) {
      additionalParams.sort_by = 'inventory_available:desc,collection_positions.' + cleanColHandle + ':asc,published_at_ts:desc';
    }

    console.log('ℹ️ [GTECH TYPESENSE] Adapter config:', { host: HOST, displayMode: displayMode, hitsPerPage: hitsPerPageVal, apiKey: SEARCH_KEY ? '[PRESENT]' : '[MISSING]', nodes: nodesList, sort_by: additionalParams.sort_by });

    var typesenseAdapter = new window.TypesenseInstantSearchAdapter({
      server: {
        apiKey: SEARCH_KEY,
        nodes: nodesList,
        cacheSearchResultsForSeconds: 120
      },
      additionalSearchParameters: additionalParams
    });

    var urlParams = new URLSearchParams(window.location.search || '');
    var queryTerm = (context().searchQuery || urlParams.get('q') || urlParams.get('terms') || '').trim();

    var initialUiState = {};
    if (isSearchPage() && queryTerm) {
      initialUiState[COLLECTION_NAME] = {
        query: queryTerm
      };
    }

    var customRouting = {
      stateMapping: {
        stateToRoute: function (uiState) {
          var indexState = uiState[COLLECTION_NAME] || {};
          var route = {};
          if (indexState.query) {
            route.q = indexState.query;
          }
          if (indexState.page && indexState.page > 1) {
            route.page = indexState.page;
          }
          if (indexState.sortBy && indexState.sortBy !== COLLECTION_NAME) {
            route.sort_by = indexState.sortBy;
          }
          if (indexState.refinementList) {
            Object.keys(indexState.refinementList).forEach(function (key) {
              var vals = indexState.refinementList[key];
              if (vals && vals.length) {
                route[key] = vals;
              }
            });
          }
          return route;
        },
        routeToState: function (routeState) {
          var qVal = routeState.q || (isSearchPage() ? queryTerm : '');
          var refinements = {};
          var recognizedFacets = [
            'category_group', 'category_name', 'category_facet',
            'base_color', 'available_sizes', 'length',
            'collection_rises', 'collection_styles', 'necklines', 'product_type', 'vendor'
          ];
          recognizedFacets.forEach(function (facetKey) {
            if (routeState[facetKey]) {
              refinements[facetKey] = Array.isArray(routeState[facetKey])
                ? routeState[facetKey]
                : [routeState[facetKey]];
            }
          });

          var indexState = {
            query: qVal,
            page: routeState.page || 1,
            refinementList: refinements
          };
          if (routeState.sort_by) {
            indexState.sortBy = routeState.sort_by;
          }

          var state = {};
          state[COLLECTION_NAME] = indexState;
          return state;
        }
      }
    };

    var fallbackAdapter = null;
    if (FALLBACK_HOST && FALLBACK_SEARCH_KEY) {
      try {
        var fallbackNodesList = Array.isArray(window.GTECH_TYPESENSE_FALLBACK_NODES) && window.GTECH_TYPESENSE_FALLBACK_NODES.length > 0
          ? window.GTECH_TYPESENSE_FALLBACK_NODES
          : [{ host: FALLBACK_HOST, port: FALLBACK_PORT, protocol: FALLBACK_PROTOCOL }];
        fallbackAdapter = new window.TypesenseInstantSearchAdapter({
          server: {
            apiKey: FALLBACK_SEARCH_KEY,
            nodes: fallbackNodesList,
            cacheSearchResultsForSeconds: 120
          },
          additionalSearchParameters: Object.assign({}, additionalParams)
        });
      } catch (fbInitErr) {
        console.warn('⚠️ [GTECH TYPESENSE] Fallback adapter init error:', fbInitErr);
      }
    }

    function adaptRequestsForFallback(reqs) {
      if (!FALLBACK_COLLECTION || FALLBACK_COLLECTION === COLLECTION_NAME) {
        return reqs;
      }
      return (reqs || []).map(function (req) {
        var cloned = Object.assign({}, req);
        if (cloned.indexName === COLLECTION_NAME) {
          cloned.indexName = FALLBACK_COLLECTION;
        }
        return cloned;
      });
    }

    function adaptResponseFromFallback(resp) {
      if (FALLBACK_COLLECTION && FALLBACK_COLLECTION !== COLLECTION_NAME && resp && resp.results) {
        resp.results.forEach(function (r) {
          if (r && r.index === FALLBACK_COLLECTION) {
            r.index = COLLECTION_NAME;
          }
        });
      }
      return resp;
    }

    var isUsingFallback = false;
    var rawSearchClient = typesenseAdapter.searchClient;
    var safeSearchClient = {
      search: function (requests) {
        function executeWithClient(client, isFallback) {
          var targetRequests = isFallback ? adaptRequestsForFallback(requests) : requests;
          return client.search(targetRequests).then(function (response) {
            if (isFallback) {
              adaptResponseFromFallback(response);
            }
            if (response && response.results && response.results.some(function (r) { return r && (r.error || (r.code && r.code >= 400)); })) {
              if (!isFallback && fallbackAdapter) {
                console.warn('⚠️ [GTECH TYPESENSE] Primary server returned error response, falling back to backup host:', FALLBACK_HOST);
                isUsingFallback = true;
                return executeWithClient(fallbackAdapter.searchClient, true);
              }
              console.warn('⚠️ [GTECH TYPESENSE] Error in search response, running fallback sort...', response.results);
              var fallbackSort = isSearchPage() ? 'inventory_available:desc,published_at_ts:desc' : 'published_at_ts:desc';
              var fallbackRequests = (targetRequests || []).map(function (req) {
                var cloned = Object.assign({}, req);
                if (cloned.params) {
                  cloned.params = Object.assign({}, cloned.params);
                  cloned.params.sort_by = fallbackSort;
                }
                return cloned;
              });
              return client.search(fallbackRequests).then(function (res2) {
                return isFallback ? adaptResponseFromFallback(res2) : res2;
              }).catch(function () {
                return response;
              });
            }
            return response;
          });
        }

        if (isUsingFallback && fallbackAdapter) {
          return executeWithClient(fallbackAdapter.searchClient, true);
        }

        return executeWithClient(rawSearchClient, false).catch(function (primaryErr) {
          console.warn('⚠️ [GTECH TYPESENSE] Primary search node failed, trying backup host:', FALLBACK_HOST, primaryErr);
          if (fallbackAdapter) {
            isUsingFallback = true;
            return executeWithClient(fallbackAdapter.searchClient, true);
          }
          throw primaryErr;
        }).catch(function (error) {
          var errMsg = error && (error.message || String(error));
          console.warn('⚠️ [GTECH TYPESENSE] All search nodes failed:', errMsg);
          return {
            results: (requests || []).map(function (req) {
              return {
                hits: [],
                nbHits: 0,
                page: 0,
                nbPages: 0,
                hitsPerPage: hitsPerPageVal || 36,
                processingTimeMS: 1,
                exhaustiveNbHits: true,
                query: (req && req.params && req.params.query) || '',
                params: '',
                facets: {},
                facets_stats: {}
              };
            })
          };
        });
      },
      searchForFacetValues: function (requests) {
        var client = (isUsingFallback && fallbackAdapter) ? fallbackAdapter.searchClient : rawSearchClient;
        if (typeof client.searchForFacetValues === 'function') {
          var targetRequests = (isUsingFallback && fallbackAdapter) ? adaptRequestsForFallback(requests) : requests;
          return client.searchForFacetValues(targetRequests);
        }
      }
    };

    var widgets = window.instantsearch.widgets;
    searchInstance = window.instantsearch({
      indexName: COLLECTION_NAME,
      searchClient: safeSearchClient,
      initialUiState: initialUiState,
      routing: customRouting
    });

    // Collection / Search Configuration
    var configureObj = { hitsPerPage: hitsPerPageVal };

    // Search Page Handling
    var shouldHideNoImage = context().hideNoImageProducts !== false && (root ? root.getAttribute('data-hide-no-image') !== 'false' : true);
    if (isSearchPage()) {
      if (shouldHideNoImage) {
        configureObj.filters = 'has_image:=true';
      }
    } else {
      var parentCollectionMap = {
        'bottoms': ['womens-bottoms', 'mens-bottoms'],
        'tops': ['womens-tops', 'mens-tops'],
        'sweatshirts-sweatpants': ['womens-sweatshirts-sweatpants', 'mens-sweatshirts-sweatpants'],
        'jackets-coats': ['womens-jackets-coats', 'mens-jackets-coats'],
        'sleepwear': ['womens-sleepwear', 'womens-sleep-lounge-sets', 'womens-sleep-tops'],
        'dresses': ['womens-dresses', 'womens-dresses-rompers'],
        'others': ['womens-others', 'mens-others']
      };

      var filterParts = [];
      var handle = String(collectionHandle || '').toLowerCase().trim();
      if (parentCollectionMap[handle]) {
        filterParts.push('collections:=[' + parentCollectionMap[handle].join(', ') + ']');
      } else if (collectionId) {
        filterParts.push('collection_ids:=[' + collectionId + ']');
      } else if (handle) {
        filterParts.push('collections:=[' + handle + ']');
      }

      var priceRule = (root.getAttribute('data-price-rule') || 'mixed').toLowerCase().trim();
      if (priceRule === 'full_price') {
        filterParts.push('has_full_price_variants:=true');
      } else if (priceRule === 'sales_price' || priceRule === 'sale') {
        filterParts.push('has_sale_variants:=true');
      }

      if (shouldHideNoImage) {
        filterParts.push('has_image:=true');
      }

      if (filterParts.length > 0) {
        configureObj.filters = filterParts.join(' && ');
      }
    }

    console.log('ℹ️ [GTECH TYPESENSE] Context:', context());
    console.log('ℹ️ [GTECH TYPESENSE] Configure parameters:', configureObj);

    var hitsContainer = root.querySelector('[data-gtech-instant-hits]');
    var paginationContainer = root.querySelector('[data-gtech-instant-pagination]');
    console.log('ℹ️ [GTECH TYPESENSE] Containers check:', { hitsContainer: hitsContainer, paginationContainer: paginationContainer });

    var instantWidgets = [
      widgets.configure(configureObj),
      widgets.hits({
        container: root.querySelector('[data-gtech-instant-hits]'),
        transformItems: function (items) {
          var filtered = items || [];
          if (shouldHideNoImage) {
            filtered = filtered.filter(function (item) {
              var img = item.main_image || item.product_image || (item.images && item.images[0]) || '';
              return img && String(img).trim() !== '' && !String(img).includes('no-image');
            });
          }
          if (isSearchPage()) {
            filtered.sort(function (a, b) {
              var aAvail = a && a.inventory_available !== false ? 1 : 0;
              var bAvail = b && b.inventory_available !== false ? 1 : 0;
              return bAvail - aAvail;
            });
          }
          return filtered.map(function (item, index) {
            item.__hitIndex = index;
            return item;
          });
        },
        templates: {
          item: function (hit, bindContext) {
            var idx = (bindContext && typeof bindContext.__hitIndex === 'number')
              ? bindContext.__hitIndex
              : (typeof hit.__hitIndex === 'number' ? hit.__hitIndex : 99);
            return hitTemplate(hit, idx);
          },
          empty: '<div class="gtech-instant-empty-state"><p class="gtech-instant-empty-state__message">' + escapeAttr(t('no_results', 'SORRY, NO MATCH FOUND FOR YOUR SEARCH CRITERIA.')) + '</p></div>'
        }
      })
    ];

    // Hollister Style Custom Pagination: << < 1 of 4 > >>
    var paginationContainer = root.querySelector('[data-gtech-instant-pagination]');
    if (paginationContainer) {
      if (window.instantsearch && window.instantsearch.connectors && window.instantsearch.connectors.connectPagination) {
        var createCustomPagination = window.instantsearch.connectors.connectPagination(function (renderOptions, isFirstRender) {
          var container = renderOptions.widgetParams.container;
          if (!container) return;

          var currentRefinement = renderOptions.currentRefinement; // 0-indexed
          var nbPages = renderOptions.nbPages;
          var isFirstPage = renderOptions.isFirstPage;
          var isLastPage = renderOptions.isLastPage;
          var refine = renderOptions.refine;

          if (!nbPages || nbPages <= 1) {
            container.innerHTML = '';
            container.style.display = 'none';
            return;
          }
          container.style.display = '';

          var currentPageNum = currentRefinement + 1;

          var html =
            '<div class="gtech-instant-pagination">' +
              '<div class="gtech-instant-pagination__track">' +
                '<button class="gtech-instant-pagination__btn gtech-instant-pagination__btn--first' + (isFirstPage ? ' is-disabled' : '') + '" ' + (isFirstPage ? 'disabled' : '') + ' type="button" aria-label="' + escapeAttr(t('pagination_first', 'First page')) + '" data-page="0">' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline></svg>' +
                '</button>' +
                '<button class="gtech-instant-pagination__btn gtech-instant-pagination__btn--prev' + (isFirstPage ? ' is-disabled' : '') + '" ' + (isFirstPage ? 'disabled' : '') + ' type="button" aria-label="' + escapeAttr(t('pagination_prev', 'Previous page')) + '" data-page="' + (currentRefinement - 1) + '">' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>' +
                '</button>' +
                '<span class="gtech-instant-pagination__status">' +
                  currentPageNum + ' ' + escapeAttr(t('pagination_of', 'of')) + ' ' + nbPages +
                '</span>' +
                '<button class="gtech-instant-pagination__btn gtech-instant-pagination__btn--next' + (isLastPage ? ' is-disabled' : '') + '" ' + (isLastPage ? 'disabled' : '') + ' type="button" aria-label="' + escapeAttr(t('pagination_next', 'Next page')) + '" data-page="' + (currentRefinement + 1) + '">' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
                '</button>' +
                '<button class="gtech-instant-pagination__btn gtech-instant-pagination__btn--last' + (isLastPage ? ' is-disabled' : '') + '" ' + (isLastPage ? 'disabled' : '') + ' type="button" aria-label="' + escapeAttr(t('pagination_last', 'Last page')) + '" data-page="' + (nbPages - 1) + '">' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline></svg>' +
                '</button>' +
              '</div>' +
            '</div>';

          container.innerHTML = html;

          var buttons = container.querySelectorAll('.gtech-instant-pagination__btn:not(:disabled)');
          buttons.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              var targetPage = parseInt(btn.getAttribute('data-page'), 10);
              if (!isNaN(targetPage) && targetPage >= 0 && targetPage < nbPages) {
                refine(targetPage);
                var scrollTarget = root.querySelector('.gtech-instant__filterbar') || root;
                if (scrollTarget) {
                  scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }
            });
          });
        });

        instantWidgets.push(
          createCustomPagination({
            container: paginationContainer
          })
        );
      } else {
        instantWidgets.push(
          widgets.pagination({
            container: paginationContainer,
            scrollTo: root
          })
        );
      }
    }

    // Search Box Widget (if element exists)
    var searchBoxContainer = root.querySelector('[data-gtech-instant-searchbox]');
    if (searchBoxContainer) {
      instantWidgets.push(
        widgets.searchBox({
          container: searchBoxContainer,
          placeholder: t('search_placeholder', 'Search products...')
        })
      );
    }

    // Sort Options
    var sortItemsList = [
      { label: t('sort_featured', 'Featured'), value: COLLECTION_NAME },
      { label: t('sort_best_selling', 'Best Selling'), value: COLLECTION_NAME + '/sort/inventory_available:desc,sort_best_selling:desc,created_at_ts:desc' },
      { label: t('sort_price_asc', 'Price: Low to High'), value: COLLECTION_NAME + '/sort/inventory_available:desc,price:asc' },
      { label: t('sort_price_desc', 'Price: High to Low'), value: COLLECTION_NAME + '/sort/inventory_available:desc,price:desc' },
      { label: t('sort_newest', 'Newest'), value: COLLECTION_NAME + '/sort/inventory_available:desc,published_at_ts:desc' }
    ];

    // Sort By Widget
    var sortDesktop = root.querySelector('[data-gtech-instant-sort-desktop-container]');
    if (sortDesktop) {
      instantWidgets.push(
        widgets.sortBy({
          container: sortDesktop,
          items: sortItemsList
        })
      );
    }

    // CurrentRefinements & ClearRefinements Widgets (Front row only)
    var clearDesktop = root.querySelector('[data-gtech-instant-clear-desktop]');
    if (clearDesktop) {
      instantWidgets.push(
        widgets.clearRefinements({
          container: clearDesktop,
          templates: {
            resetLabel: t('clear_all', 'Clear All')
          }
        })
      );
    }

    var currentDesktop = root.querySelector('[data-gtech-instant-current-desktop]');
    if (currentDesktop) {
      instantWidgets.push(
        widgets.currentRefinements({
          container: currentDesktop
        })
      );
    }

    // Facet Configurations (Metafield & Hierarchy Overrides)
    var allFacetDefinitions = {
      category_group: { attribute: 'category_group', label: t('category', 'Category'), limit: 40, transformItems: transformCategoryFacetItems },
      category_name: { attribute: 'category_name', label: t('category', 'Category'), limit: 40, transformItems: transformCategoryFacetItems },
      category_facet: { attribute: 'category_facet', label: t('category', 'Category'), limit: 40, transformItems: transformCategoryFacetItems },
      base_color: { attribute: 'base_color', label: t('color', 'Color'), limit: 20, transformItems: transformAlphabeticalFacetItems },
      available_sizes: { attribute: 'available_sizes', label: t('size', 'Size'), limit: 30, transformItems: transformSizeFacetItems },
      length: { attribute: 'length', label: t('length', 'Length'), limit: 15, transformItems: transformLengthFacetItems },
      collection_rises: { attribute: 'collection_rises', label: t('rise', 'Rise'), limit: 10, transformItems: transformRiseFacetItems },
      collection_styles: { attribute: 'collection_styles', label: t('style', 'Style'), limit: 30, transformItems: transformAlphabeticalFacetItems },
      necklines: { attribute: 'necklines', label: t('neckline', 'Neckline'), limit: 25, transformItems: transformAlphabeticalFacetItems },
      product_type: { attribute: 'product_type', label: t('product_type', 'Product Type'), limit: 20, transformItems: transformAlphabeticalFacetItems },
      vendor: { attribute: 'vendor', label: t('vendor', 'Vendor'), limit: 15, transformItems: transformAlphabeticalFacetItems }
    };

    var customFiltersAttr = root.getAttribute('data-collection-filters');
    var facetConfigList = [];
    if (customFiltersAttr) {
      var requestedFacets = customFiltersAttr
        .split(',')
        .map(function (s) { return s.trim().toLowerCase(); })
        .filter(Boolean);

      requestedFacets.forEach(function (key) {
        if (key === 'category' || key === 'category_group' || key === 'categories') {
          facetConfigList.push(allFacetDefinitions.category_group);
        } else if (key === 'category_name') {
          facetConfigList.push(allFacetDefinitions.category_name);
        } else if (key === 'category_facet') {
          facetConfigList.push(allFacetDefinitions.category_facet);
        } else if (key === 'color' || key === 'colors' || key === 'base_color') {
          facetConfigList.push(allFacetDefinitions.base_color);
        } else if (key === 'size' || key === 'sizes' || key === 'available_sizes') {
          facetConfigList.push(allFacetDefinitions.available_sizes);
        } else if (key === 'length' || key === 'lengths') {
          facetConfigList.push(allFacetDefinitions.length);
        } else if (key === 'rise' || key === 'rises' || key === 'collection_rises') {
          facetConfigList.push(allFacetDefinitions.collection_rises);
        } else if (key === 'style' || key === 'styles' || key === 'fit' || key === 'fits' || key === 'collection_styles') {
          facetConfigList.push(allFacetDefinitions.collection_styles);
        } else if (key === 'neckline' || key === 'necklines') {
          facetConfigList.push(allFacetDefinitions.necklines);
        } else if (key === 'product_type' || key === 'type') {
          facetConfigList.push(allFacetDefinitions.product_type);
        } else if (key === 'vendor' || key === 'brand') {
          facetConfigList.push(allFacetDefinitions.vendor);
        }
      });


    }

    // Default facet order when no custom metafield filter is defined
    if (facetConfigList.length === 0) {
      facetConfigList = [
        allFacetDefinitions.category_group,
        allFacetDefinitions.available_sizes,
        allFacetDefinitions.base_color,
        allFacetDefinitions.length,
        allFacetDefinitions.collection_rises,
        allFacetDefinitions.collection_styles,
        allFacetDefinitions.necklines,
        allFacetDefinitions.product_type
      ];
    }

    // Ensure Size is always ordered before Color (Hollister standard)
    if (!customFiltersAttr) {
      var sizeIdx = -1;
      var colorIdx = -1;
      for (var i = 0; i < facetConfigList.length; i++) {
        if (facetConfigList[i].attribute === 'available_sizes') sizeIdx = i;
        if (facetConfigList[i].attribute === 'base_color') colorIdx = i;
      }
      if (sizeIdx !== -1 && colorIdx !== -1 && colorIdx < sizeIdx) {
        var sizeFacet = facetConfigList.splice(sizeIdx, 1)[0];
        facetConfigList.splice(colorIdx, 0, sizeFacet);
      }
    }

    // Sync horizontal filterbar small chips beside Filter & Sort
    syncFilterbarChips(root, facetConfigList);

    // Sort By Widget in Drawer
    var sortDrawer = root.querySelector('[data-gtech-instant-sort-drawer]');
    if (sortDrawer) {
      instantWidgets.push(
        widgets.sortBy({
          container: sortDrawer,
          items: sortItemsList
        })
      );
    }

    // Build Desktop & Mobile Facet Containers & Widgets
    var desktopSidebar = root.querySelector('[data-gtech-instant-sidebar-facets]');
    var mobileDrawer = root.querySelector('[data-gtech-instant-facets]');
    var mobileDrawerWrapper = (mobileDrawer && mobileDrawer.querySelector('[data-gtech-instant-facets-wrapper]')) || mobileDrawer;

    facetConfigList.forEach(function (facet) {
      // Build container markup in desktop sidebar
      if (desktopSidebar) {
        var desktopFacetWrap = document.createElement('div');
        desktopFacetWrap.className = 'gtech-instant__facet';
        desktopFacetWrap.setAttribute('data-gtech-instant-panel', facet.attribute);
        desktopFacetWrap.innerHTML = createFacetAccordionMarkup(facet.attribute + '-desktop', facet.label, false, facet.attribute);
        desktopSidebar.appendChild(desktopFacetWrap);

        var refWidgetOpts = {
          container: '#typesense-facet-' + facet.attribute + '-desktop',
          attribute: facet.attribute,
          limit: facet.limit || 10,
          showMore: true,
          showMoreLimit: (facet.limit || 10) + 100,
          sortBy: ['name:asc']
        };
        if (facet.transformItems) {
          refWidgetOpts.transformItems = facet.transformItems;
        }
        instantWidgets.push(widgets.refinementList(refWidgetOpts));
      }

      // Build container markup in mobile drawer
      if (mobileDrawerWrapper) {
        var mobileFacetWrap = document.createElement('div');
        mobileFacetWrap.className = 'gtech-instant__facet';
        mobileFacetWrap.setAttribute('data-gtech-instant-panel', facet.attribute);
        mobileFacetWrap.setAttribute('data-panel-active', 'true');
        mobileFacetWrap.setAttribute('data-accordion-open', 'false');
        mobileFacetWrap.innerHTML = createFacetAccordionMarkup(facet.attribute + '-mobile', facet.label, true, facet.attribute);
        mobileDrawerWrapper.appendChild(mobileFacetWrap);

        var refMobileOpts = {
          container: '#typesense-facet-' + facet.attribute + '-mobile',
          attribute: facet.attribute,
          limit: facet.limit || 10,
          showMore: true,
          showMoreLimit: (facet.limit || 10) + 100,
          sortBy: ['name:asc']
        };
        if (facet.transformItems) {
          refMobileOpts.transformItems = facet.transformItems;
        }
        instantWidgets.push(widgets.refinementList(refMobileOpts));
      }
    });

    searchInstance.addWidgets(instantWidgets);

    searchInstance.on('render', function () {
      root.classList.remove('is-loading-results');
      console.log('🎨 [GTECH TYPESENSE] Render event fired!');
      var hitsContainer = root.querySelector('[data-gtech-instant-hits]');
      console.log('  Rendered hits count:', hitsContainer ? hitsContainer.children.length : 0);

      var nbHits = (searchInstance.helper && searchInstance.helper.lastResults) ? searchInstance.helper.lastResults.nbHits : null;
      if (nbHits === 0 && hitsContainer) {
        var existingEmpty = hitsContainer.querySelector('.gtech-instant-empty-state');
        if (!existingEmpty) {
          hitsContainer.innerHTML = '<div class="ais-Hits"><div class="gtech-instant-empty-state"><p class="gtech-instant-empty-state__message">' + escapeAttr(t('no_results', 'SORRY, NO MATCH FOUND FOR YOUR SEARCH CRITERIA.')) + '</p></div></div>';
        }
      }

      if (hitsContainer) bindCardEvents(hitsContainer);
      updateDrawerResultCount(root);
      updateFilterChipCounts(root);
      groupCategoryFacetInDOM(root);
      formatSizeFacetDOM(root);
      renderGridPromoBanners(root);

      // Auto-toggle visibility of facet accordions and chips based on whether facet has items in current results
      var lastResults = searchInstance && searchInstance.helper && searchInstance.helper.lastResults;
      var facetWraps = root.querySelectorAll('.gtech-instant__facet');
      var facetHasItemsMap = {};

      facetWraps.forEach(function (wrap) {
        var panelAttr = wrap.getAttribute('data-gtech-instant-panel');
        if (!panelAttr) return;

        var content = wrap.querySelector('.gtech-instant__facet-content, .gtech-instant__facet-body');
        var hasItems = false;
        if (content) {
          hasItems = content.querySelectorAll('.ais-RefinementList-item').length > 0;
        }

        // If InstantSearch helper has lastResults, also check facets count directly
        if (!hasItems && lastResults && lastResults.facets) {
          var fObj = lastResults.facets.find(function (f) { return f.name === panelAttr; });
          if (fObj && fObj.data && Object.keys(fObj.data).length > 0) {
            hasItems = true;
          }
        }

        wrap.style.display = hasItems ? '' : 'none';
        if (hasItems) {
          facetHasItemsMap[panelAttr] = true;
        }
      });

      // Update horizontal filterbar chips
      var allFacetChips = root.querySelectorAll('[data-gtech-instant-facet-chip]');
      allFacetChips.forEach(function (chip) {
        var panelAttr = chip.getAttribute('data-gtech-instant-facet-chip');
        if (!panelAttr) return;

        // If lastResults not available yet, keep chips visible
        if (!lastResults) {
          chip.style.display = '';
        } else {
          var hasItems = Boolean(facetHasItemsMap[panelAttr]);
          chip.style.display = hasItems ? '' : 'none';
        }
      });
    });

    searchInstance.start();
    console.log('🚀 [GTECH TYPESENSE] searchInstance.start() executed!');

    if (searchInstance.helper) {
      searchInstance.helper.on('search', function () {
        root.classList.add('is-loading-results');
      });
      searchInstance.helper.on('error', function (err) {
        console.warn('⚠️ [GTECH TYPESENSE] Helper error event:', err);
        root.classList.remove('is-loading-results');
        var hitsContainer = root.querySelector('[data-gtech-instant-hits]');
        if (hitsContainer) {
          hitsContainer.innerHTML = '<div class="ais-Hits"><div class="gtech-instant-empty-state"><p class="gtech-instant-empty-state__message">' + escapeAttr(t('no_results', 'SORRY, NO MATCH FOUND FOR YOUR SEARCH CRITERIA.')) + '</p></div></div>';
        }
      });
    }

    if (isSearchPage() && queryTerm && searchInstance.helper) {
      if (searchInstance.helper.state.query !== queryTerm) {
        searchInstance.helper.setQuery(queryTerm).search();
      }
    }
    initDrawerEvents();
    initFilterbarDragScroll(root);
    initQuickAddModalListeners();
    initMobileCategoryDropdown();
    renderCollectionNavTree(root);

    document.body.classList.add('gtech-own-instantsearch', 'gtech-instantsearch-active');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTypesenseEngine);
  } else {
    initTypesenseEngine();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && (e.target.classList.contains('section-gtech-typesense') || e.target.querySelector('[data-gtech-typesense-root]'))) {
      initTypesenseEngine();
    }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && (e.target.classList.contains('section-gtech-typesense') || e.target.querySelector('[data-gtech-typesense-root]'))) {
      initTypesenseEngine();
    }
  });
})();
